"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5634,7792],{

/***/ 98583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Az": function() { return /* binding */ StyledDate; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "HZ": function() { return /* binding */ StyledTechsItem; },
/* harmony export */   "Hz": function() { return /* binding */ StyledContent; },
/* harmony export */   "Io": function() { return /* binding */ StyledLogoTitle; },
/* harmony export */   "SM": function() { return /* binding */ StyledEllapsedTime; },
/* harmony export */   "SO": function() { return /* binding */ StyledTriggerIcon; },
/* harmony export */   "X0": function() { return /* binding */ StyledTitle; },
/* harmony export */   "hr": function() { return /* binding */ StyledTechsLogo; },
/* harmony export */   "nO": function() { return /* binding */ StyledExtraContent; },
/* harmony export */   "ps": function() { return /* binding */ StyledLogo; },
/* harmony export */   "qQ": function() { return /* binding */ StyledPreTitle; },
/* harmony export */   "rg": function() { return /* binding */ StyledCard; },
/* harmony export */   "tr": function() { return /* binding */ StyledTrigger; },
/* harmony export */   "wy": function() { return /* binding */ StyledTechsList; },
/* harmony export */   "xD": function() { return /* binding */ StyledTechsTitle; },
/* harmony export */   "yG": function() { return /* binding */ StyledDesc; },
/* harmony export */   "yK": function() { return /* binding */ StyledLogoEduTitle; },
/* harmony export */   "zn": function() { return /* binding */ StyledDateRange; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);
/* harmony import */ var _about_me_ClassicCVAbout_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94252);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: grid;\n    grid-template-columns: 14.25rem 1fr;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    align-items: flex-end;\n    border-right: 1px solid ",
        ";\n    padding-right: ",
        ";\n    margin-right: ",
        ";\n    margin-bottom: 0;\n  }\n\n  img {\n    margin-bottom: ",
        ";\n    display: block;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.16;\n  font-weight: ",
        ";\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.25;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  text-align: right;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  @media (min-width: ",
        ") {\n    text-align: right;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "::after {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.16;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #999;\n  font-weight: ",
        ";\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.16;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  font-weight: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.25;\n  }\n\n  > div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n\n  > * {\n    display: flex;\n    align-items: center;\n  }\n\n  > :first-child::after {\n    content: '';\n    width: ",
        ";\n    height: 1px;\n    background-color: ",
        ";\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  padding-left: ",
        ";\n  color: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-appearance: none;\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n  background-color: transparent;\n  border-radius: 0;\n  border: 0;\n  padding: 0;\n  text-align: left;\n  font-family: inherit;\n  color: inherit;\n  cursor: pointer;\n  transition: 0.3s;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active {\n    color: ",
        ";\n  }\n\n  &.is-active {\n    ",
        " svg {\n      transform: rotate(180deg);\n      transform-origin: center center;\n    }\n  }\n\n  > span {\n    word-break: break-word;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n  max-height: 0;\n\n  &.is-active {\n    max-height: var(--content-height);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ul,\n  ol {\n    margin-left: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  ul li {\n    list-style-type: disc;\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  font-size: ",
        ";\n  line-height: 1.14;\n  text-transform: uppercase;\n  letter-spacing: 0.25em;\n  font-weight: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  width: ",
        ";\n\n  img {\n    width: ",
        ";\n    height: ",
        ";\n    display: block;\n    filter: grayscale(100%);\n\n    @media (min-width: ",
        ") {\n      width: ",
        ";\n      height: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var StyledCard = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"));
var StyledLogo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledLogoTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var StyledLogoEduTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-68f3a684-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"));
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-4"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"));
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-5"
})(_templateObject5(), _about_me_ClassicCVAbout_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledShowMore */ .em);
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-68f3a684-6"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var StyledPreTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-7"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"));
var StyledDate = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-8"
})(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledDateRange = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-9"
})(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
var StyledEllapsedTime = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-68f3a684-10"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle"));
var StyledTriggerIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-11"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_300"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledTrigger = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-68f3a684-12"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("link_hover"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("link_active"), StyledTriggerIcon);
var StyledExtraContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-13"
})(_templateObject13());
var StyledDesc = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-14"
})(_templateObject14(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledTechsTitle = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-68f3a684-15"
})(_templateObject15(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"));
var StyledTechsList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-68f3a684-16"
})(_templateObject16(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
var StyledTechsItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-68f3a684-17"
})(_templateObject17(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"));
var StyledTechsLogo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68f3a684-18"
})(_templateObject18(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"));


/***/ }),

/***/ 6897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ classic_PublicProfileClassic; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ./components/publicProfile/shared/CVBookmarks.tsx + 3 modules
var CVBookmarks = __webpack_require__(45625);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(97000);
;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVAbout.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_FROM_LINKEDIN = {
    introduction: false,
    languages: false,
    technologies: false
};
var BREAKPOINT_COLUMNS = {
    default: 2,
    671: 1
};

// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./services/ui/publicprofile/publicprofile.service.ts
var publicprofile_service = __webpack_require__(27595);
;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVAbout.hooks.ts




// Custom hook.
// -----------------------------------------------------------------------------
var useClassicCVAbout = function(param) {
    var manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Variables.
    // ---------------------------------------------------------------------------
    var hasOnlyDesc = (0,react.useMemo)(function() {
        var bestPractices = manfredite.bestPractices, softSkills = manfredite.softSkills, languages = manfredite.languages, facts = manfredite.facts;
        return !publicprofile_service/* default.hasAnyTech */.Z.hasAnyTech(manfredite) && !bestPractices && !(0,lodash.isEmpty)(languages) && !(0,lodash.isEmpty)(softSkills) && !(0,lodash.isEmpty)(facts);
    }, [
        manfredite
    ]);
    var hasGeneralInfo = (0,react.useMemo)(function() {
        return publicprofile_service/* default.hasGeneralInfo */.Z.hasGeneralInfo(manfredite);
    }, [
        manfredite
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        hasGeneralInfo: hasGeneralInfo,
        hasOnlyDesc: hasOnlyDesc,
        t: t
    };
};

// EXTERNAL MODULE: ./components/publicProfile/classic/about-me/ClassicCVAbout.styled.ts
var ClassicCVAbout_styled = __webpack_require__(94252);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVLinkedIn.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_FIRTS_OF_COLUMN = false;
var DEFAULT_FIRST_OF_ROW = false;
var DEFAULT_IS_SECTION = false;

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVLinkedIn.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* Positioning */\n    position: relative;\n    z-index: 20;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Display & Box Model */\n  align-items: center;\n  border-top-right-radius: ",
        ";\n  border-top-left-radius: ",
        ";\n  background-color: #30abd5;\n  display: flex;\n  padding: ",
        ";\n  height: ",
        ";\n  width: fit-content;\n\n  /* Text */\n  font-size: 12px;\n  font-weight: 900;\n  line-height: 12px;\n\n  /* Color */\n  color: white;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  span {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* Display & Box Model */\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n    padding: ",
        " ",
        ";\n\n    /* Color */\n    background-color: white;\n\n    ",
        "\n\n    h1 {\n      line-height: 1 !important;\n      margin-bottom: 0 !important;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


// styled-components.
// -----------------------------------------------------------------------------
var ClassicCVLinkedInRoot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b0ebe9d-0"
})(_templateObject1(), function(param) {
    var firstOfColumn = param.firstOfColumn, firstOfRow = param.firstOfRow;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), firstOfColumn && "\n      margin-bottom: 50px;\n      margin-top: -72px;\n    ", firstOfRow && "\n      margin-top: -30px;\n    ");
});
var ClassicCVLinkedInIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b0ebe9d-1"
})(_templateObject2(), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl"));
var ClassicCVLinkedInContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6b0ebe9d-2"
})(_templateObject4(), function(param) {
    var isSection = param.isSection;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), isSection && "padding: 40px 20px 20px;");
});

;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVLinkedIn.tsx






// Component.
// -----------------------------------------------------------------------------
var ClassicCVLinkedIn = function(param) {
    var children = param.children, _firstOfColumn = param.firstOfColumn, firstOfColumn = _firstOfColumn === void 0 ? DEFAULT_FIRTS_OF_COLUMN : _firstOfColumn, _firstOfRow = param.firstOfRow, firstOfRow = _firstOfRow === void 0 ? DEFAULT_FIRST_OF_ROW : _firstOfRow, _isSection = param.isSection, isSection = _isSection === void 0 ? DEFAULT_IS_SECTION : _isSection;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVLinkedInRoot, {
        firstOfColumn: firstOfColumn,
        firstOfRow: firstOfRow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVLinkedInIcon, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_brands_svg_icons/* faLinkedin */.D9H
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("fromLinkedIn")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedInContent, {
                isSection: isSection,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVAboutMarkdownContent.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var ClassicCVAboutMarkdownContent_constants_DEFAULT_FROM_LINKEDIN = false;

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVAboutMarkdownContent.hooks.ts


// Custom hooks.
// -----------------------------------------------------------------------------
var useClassicCVAboutMarkdownContent = function() {
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = (0,react.useState)(false), displayReadMore = ref[0], setdisplayReadMore = ref[1];
    var ref1 = (0,react.useState)(false), showAllText = ref1[0], setShowAllText = ref1[1];
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var clampableText = (0,react.useRef)(null);
    // Functions.
    // ---------------------------------------------------------------------------
    var checkLineClamp = (0,react.useCallback)(function() {
        if (clampableText.current && clampableText.current.clientHeight < clampableText.current.scrollHeight) {
            setdisplayReadMore(true);
        } else {
            setdisplayReadMore(false);
        }
    }, []);
    // Handlers.
    // ---------------------------------------------------------------------------
    var handleSetAllText = (0,react.useCallback)(function() {
        setShowAllText(!showAllText);
    }, [
        showAllText
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(function() {
        checkLineClamp();
    }, [
        checkLineClamp
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        clampableText: clampableText,
        displayReadMore: displayReadMore,
        onSetAllText: handleSetAllText,
        showAllText: showAllText,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVAboutMarkdownContent.tsx









// Component.
// -----------------------------------------------------------------------------
var ClassicCVAboutMarkdownContent = function(param) {
    var _fromLinkedIn = param.fromLinkedIn, fromLinkedIn = _fromLinkedIn === void 0 ? ClassicCVAboutMarkdownContent_constants_DEFAULT_FROM_LINKEDIN : _fromLinkedIn, title = param.title, content = param.content;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVAboutMarkdownContent(), clampableText = ref.clampableText, displayReadMore = ref.displayReadMore, onSetAllText = ref.onSetAllText, showAllText = ref.showAllText, t = ref.t;
    // Guard clauses.
    if (!content || !content.trim()) {
        return null;
    }
    // Functions.
    // ---------------------------------------------------------------------------
    var renderContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVAbout_styled/* StyledSubSection */.XX, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledTitle */.X0, {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledText */.qY, {
                    ref: clampableText,
                    className: classnames_default()({
                        "display-full-text": showAllText
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                        content: content
                    })
                }),
                displayReadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledShowMore */.em, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: onSetAllText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: showAllText ? pro_solid_svg_icons/* faMinusCircle */.uMC : pro_solid_svg_icons/* faPlusCircle */.KtF
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("".concat(showAllText ? "readLess" : "readMore"))
                            })
                        ]
                    })
                })
            ]
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return fromLinkedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
        firstOfColumn: true,
        isSection: true,
        children: renderContent()
    }) : renderContent();
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVFacts.styled.tsx

function ClassicCVFacts_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    ClassicCVFacts_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassicCVFacts_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-weight: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    ClassicCVFacts_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClassicCVFacts_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  line-height: 1.2;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  ul {\n    padding-left: 1em;\n  }\n\n  li {\n    list-style: disc;\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    ClassicCVFacts_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


// styled-components.
// -----------------------------------------------------------------------------
var StyledFact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-132b9734-0"
})(ClassicCVFacts_styled_templateObject(), (0,theme/* spacing */.W0)("lg"));
var StyledFactTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-132b9734-1"
})(ClassicCVFacts_styled_templateObject1(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("md"));
var StyledFactDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-132b9734-2"
})(ClassicCVFacts_styled_templateObject2(), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVFacts.tsx






// Component.
// -----------------------------------------------------------------------------
var ClassicCVFacts = function(param) {
    var manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Guard Conditions.
    // ---------------------------------------------------------------------------
    if (!manfredite.facts || (0,lodash.isEmpty)(manfredite.facts)) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVAbout_styled/* StyledSubSection */.XX, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledTitle */.X0, {
                children: t("about.facts")
            }),
            manfredite.facts.map(function(f, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFact, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFactTitle, {
                            children: f.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFactDesc, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                content: f.desc
                            })
                        })
                    ]
                }, i);
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/shared/levelLadder/LevelLadder.tsx
var LevelLadder = __webpack_require__(18962);
// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVLangs.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var LEVEL_NOT_DEFINED = "not-defined";
var ClassicCVLangs_constants_DEFAULT_FROM_LINKEDIN = false;
var DEFAULT_HAS_TECHNOLOGIES = false;

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVLangs.styled.tsx

function ClassicCVLangs_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.2;\n  font-weight: ",
        ";\n  display: grid;\n  flex-direction: column;\n  grid-template-columns: min-content min-content;\n  gap: ",
        ";\n  align-items: center;\n\n  span {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n\n    &.is-not-defined {\n      grid-column: span 2;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    ClassicCVLangs_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// styled-components.
// -----------------------------------------------------------------------------
var StyledLanguages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ee310cdf-0"
})(ClassicCVLangs_styled_templateObject(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVLangs.tsx










// Component.
// // --------------------------------------------------------------------------
var ClassicCVLangs = function(param) {
    var _fromLinkedIn = param.fromLinkedIn, fromLinkedIn = _fromLinkedIn === void 0 ? ClassicCVLangs_constants_DEFAULT_FROM_LINKEDIN : _fromLinkedIn, _hasTechnologies = param.hasTechnologies, hasTechnologies = _hasTechnologies === void 0 ? DEFAULT_HAS_TECHNOLOGIES : _hasTechnologies, manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Guard Conditions.
    // ---------------------------------------------------------------------------
    if (!manfredite.languages || (0,lodash.isEmpty)(manfredite.languages)) {
        return null;
    }
    // Functions.
    // ---------------------------------------------------------------------------
    var renderContent = function() {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ClassicCVAbout_styled/* StyledSubSection */.XX, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledTitle */.X0, {
                    children: t("about.languages")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguages, {
                    children: (ref = manfredite.languages) === null || ref === void 0 ? void 0 : ref.map(function(l, i) {
                        return l.level === LEVEL_NOT_DEFINED ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "is-not-defined",
                            children: l.name
                        }, i) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: l.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelLadder/* default */.Z, {
                                    level: model/* LANGUAGES_LEVELS.indexOf */.TV.indexOf(l.level)
                                })
                            ]
                        }, i);
                    })
                })
            ]
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return fromLinkedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
        firstOfColumn: !hasTechnologies,
        isSection: true,
        children: renderContent()
    }) : renderContent();
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVSoftSkills.styled.tsx

function ClassicCVSoftSkills_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.16;\n\n  img {\n    width: ",
        ";\n    height: ",
        ";\n    filter: grayscale(100%);\n\n    @media (min-width: ",
        ") {\n      width: 3.5rem;\n      height: 3.5rem;\n    }\n  }\n"
    ]);
    ClassicCVSoftSkills_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// styled-components.
// -----------------------------------------------------------------------------
var StyledSkill = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-316777af-0"
})(ClassicCVSoftSkills_styled_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVSoftSkills.tsx






// Component.
// // --------------------------------------------------------------------------
var ClassicCVSoftSkills = function(param) {
    var manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Guard Conditions.
    // ---------------------------------------------------------------------------
    if (!manfredite.softSkills || (0,lodash.isEmpty)(manfredite.softSkills)) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVAbout_styled/* StyledSubSection */.XX, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledTitle */.X0, {
                children: t("about.skills")
            }),
            manfredite.softSkills.map(function(s, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkill, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: s.iconUrl,
                            alt: s.iconAlt,
                            "aria-hidden": true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: s.name
                        })
                    ]
                }, i);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVTechs.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var ClassicCVTechs_constants_DEFAULT_FROM_LINKEDIN = false;

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVTechs.hooks.ts



// Custom hooks.
// -----------------------------------------------------------------------------
var useClassicCVTechs = function(param) {
    var manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Variables.
    // ---------------------------------------------------------------------------
    var hasTechs = (0,react.useMemo)(function() {
        return publicprofile_service/* default.hasAnyTech */.Z.hasAnyTech(manfredite);
    }, [
        manfredite
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        hasTechs: hasTechs,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVTechsGroup.styled.tsx

function ClassicCVTechsGroup_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.25em;\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    ClassicCVTechsGroup_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassicCVTechsGroup_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n\n  li {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.15;\n    font-weight: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      gap: ",
        ";\n    }\n\n    img {\n      width: ",
        ";\n      height: ",
        ";\n      filter: grayscale(100%);\n\n      @media (min-width: ",
        ") {\n        width: ",
        ";\n        height: ",
        ";\n      }\n    }\n  }\n"
    ]);
    ClassicCVTechsGroup_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


// styled-components.
// -----------------------------------------------------------------------------
var StyledTechsTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-1c692215-0"
})(ClassicCVTechsGroup_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_300"));
var StyledTechsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1c692215-1"
})(ClassicCVTechsGroup_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVTechsGroup.tsx



// Component.
// -----------------------------------------------------------------------------
var ClassicCVTechsGroup = function(param) {
    var title = param.title, techs = param.techs;
    // Guard clauses.
    // ---------------------------------------------------------------------------
    if (!techs || (0,lodash.isEmpty)(techs)) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsList, {
                children: techs.map(function(t, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: t.iconUrl,
                                alt: t.iconAlt,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t.name
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVTechs.tsx






// Component.
// -----------------------------------------------------------------------------
var ClassicCVTechs = function(param) {
    var _fromLinkedIn = param.fromLinkedIn, fromLinkedIn = _fromLinkedIn === void 0 ? ClassicCVTechs_constants_DEFAULT_FROM_LINKEDIN : _fromLinkedIn, manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVTechs({
        manfredite: manfredite
    }), hasTechs = ref.hasTechs, t = ref.t;
    // Guard clauses.
    // ---------------------------------------------------------------------------
    if (!hasTechs) {
        return null;
    }
    // Functions.
    // ---------------------------------------------------------------------------
    var renderTechs = function() {
        var ref, ref1, ref2;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledTitle */.X0, {
                    children: t("about.techs.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVTechsGroup, {
                    techs: (ref = manfredite.techs) === null || ref === void 0 ? void 0 : ref.master,
                    title: t("about.techs.master")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVTechsGroup, {
                    techs: (ref1 = manfredite.techs) === null || ref1 === void 0 ? void 0 : ref1.like,
                    title: t("about.techs.like")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVTechsGroup, {
                    techs: (ref2 = manfredite.techs) === null || ref2 === void 0 ? void 0 : ref2.dislike,
                    title: t("about.techs.dislike")
                })
            ]
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledSubSection */.XX, {
        children: fromLinkedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
            firstOfColumn: true,
            isSection: true,
            children: renderTechs()
        }) : renderTechs()
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/ClassicCVAbout.tsx











// Component.
// -----------------------------------------------------------------------------
var ClassicCVAbout = function(param) {
    var _fromLinkedIn = param.fromLinkedIn, fromLinkedIn = _fromLinkedIn === void 0 ? DEFAULT_FROM_LINKEDIN : _fromLinkedIn, manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVAbout({
        manfredite: manfredite
    }), hasGeneralInfo = ref.hasGeneralInfo, hasOnlyDesc = ref.hasOnlyDesc, t = ref.t;
    // Guard clauses.
    // ---------------------------------------------------------------------------
    if (!hasGeneralInfo) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        id: "about-tabpanel",
        "aria-labelledby": "about-tab",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledSection */.PP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_masonry_css_module/* default */.Z, {
                breakpointCols: BREAKPOINT_COLUMNS,
                className: "masonry-grid",
                columnClassName: "masonry-column ".concat(hasOnlyDesc ? "is-full-width" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAboutMarkdownContent, {
                        content: manfredite.intro,
                        fromLinkedIn: fromLinkedIn.introduction,
                        title: t("about.introduction")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVTechs, {
                        fromLinkedIn: fromLinkedIn.technologies,
                        manfredite: manfredite
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAboutMarkdownContent, {
                        title: t("about.bestPractices"),
                        content: manfredite.bestPractices
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLangs, {
                        fromLinkedIn: fromLinkedIn.languages,
                        hasTechnologies: fromLinkedIn.technologies,
                        manfredite: manfredite
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVSoftSkills, {
                        manfredite: manfredite
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVFacts, {
                        manfredite: manfredite
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/about-me/index.ts


// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(3716);
// EXTERNAL MODULE: ./components/publicProfile/classic/ClasicCVCard.styled.ts
var ClasicCVCard_styled = __webpack_require__(98583);
;// CONCATENATED MODULE: ./components/publicProfile/classic/ClasicCVCard.tsx











var ClasicCVCard = function(param) {
    var profileItem = param.profileItem, index = param.index;
    var toggleContent = function toggleContent() {
        setActiveState(setActive === "" ? "is-active" : "");
    };
    var renderEllapsedTime = function renderEllapsedTime(from, to) {
        var ellapsedTime = publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(from, to, t);
        if (!ellapsedTime) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledEllapsedTime */.SM, {
            children: [
                "(",
                ellapsedTime,
                ")"
            ]
        });
    };
    var ref, ref1, ref2;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var content = (0,react.useRef)(null);
    var currentHeight = (ref = content.current) === null || ref === void 0 ? void 0 : ref.scrollHeight;
    var ref3 = (0,react.useState)(""), setActive = ref3[0], setActiveState = ref3[1];
    var contentHeight = {
        "--content-height": "".concat(currentHeight, "px")
    };
    (0,react.useEffect)(function() {
        if (index === 0) {
            setActiveState("is-active");
        }
    }, [
        index
    ]);
    var trimmedLink = (ref1 = profileItem.link) === null || ref1 === void 0 ? void 0 : ref1.replace(/^https?:\/\//, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledCard */.rg, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledLogo */.ps, {
                children: [
                    profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: profileItem.logoUrl,
                        alt: profileItem.logoAlt
                    }),
                    !profileItem.logoUrl && profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            profileItem.cardType != "education" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledLogoTitle */.Io, {
                                children: profileItem.company
                            }),
                            profileItem.cardType === "education" && profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledLogoEduTitle */.yK, {
                                href: profileItem.link,
                                children: profileItem.company
                            }),
                            profileItem.cardType === "education" && !profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledLogoEduTitle */.yK, {
                                as: "span",
                                children: profileItem.company
                            })
                        ]
                    }),
                    profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledLink */.Fg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            target: "_blank",
                            href: profileItem.link,
                            rel: "noreferrer",
                            children: trimmedLink
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledContent */.Hz, {
                children: [
                    profileItem.cardType === "career" && !!profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledPreTitle */.qQ, {
                        children: profileItem.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTitle */.X0, {
                        children: profileItem.title
                    }),
                    (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDate */.Az, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                profileItem.dateInitial && profileItem.dateFinal && !(0,date/* isSameDateYearAndMonth */.jm)(profileItem.dateInitial, profileItem.dateFinal) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDateRange */.zn, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                                }),
                                                profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                                })
                                            ]
                                        }),
                                        renderEllapsedTime(profileItem.dateInitial.toString(), profileItem.dateFinal.toString())
                                    ]
                                }),
                                profileItem.dateInitial && profileItem.dateFinal && (0,date/* isSameDateYearAndMonth */.jm)(profileItem.dateInitial, profileItem.dateFinal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                }),
                                profileItem.dateInitial && !profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDateRange */.zn, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("timeline.today")
                                                })
                                            ]
                                        }),
                                        renderEllapsedTime(profileItem.dateInitial.toString(), new Date().toString())
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledExtraContent */.nO, {
                        ref: content,
                        id: "content_" + profileItem.cardType + index,
                        className: "".concat(setActive),
                        style: contentHeight,
                        role: "region",
                        "aria-labelledby": "button_" + profileItem.cardType + index,
                        children: [
                            profileItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDesc */.yG, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                    content: profileItem.desc
                                })
                            }),
                            profileItem.techs && profileItem.techs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsTitle */.xD, {
                                        children: t("timeline.techs")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsList */.wy, {
                                        children: (ref2 = profileItem.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(t, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledTechsItem */.HZ, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsLogo */.hr, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: t.iconUrl,
                                                            alt: t.iconAlt
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t.name
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (profileItem.desc || profileItem.techs && profileItem.techs.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout_styled/* StyledShowMore */.em, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            id: "button_" + profileItem.cardType + index,
                            className: "".concat(setActive),
                            onClick: toggleContent,
                            "aria-expanded": setActive === "is-active",
                            "aria-controls": "content_" + profileItem.cardType + index,
                            children: [
                                setActive != "is-active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                                }),
                                setActive === "is-active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faMinusCircle */.uMC
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        setActive != "is-active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: t("readMore")
                                        }),
                                        setActive === "is-active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: t("readLess")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var classic_ClasicCVCard = (ClasicCVCard);

;// CONCATENATED MODULE: ./components/publicProfile/classic/PublicProfileClassic.styled.ts

function PublicProfileClassic_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n  }\n"
    ]);
    PublicProfileClassic_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfileClassic_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -",
        ";\n    left: 0;\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n\n    @media (min-width: ",
        ") {\n      background-color: ",
        ";\n      width: ",
        ";\n      height: ",
        ";\n      top: -",
        ";\n    }\n  }\n"
    ]);
    PublicProfileClassic_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfileClassic_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: ",
        ";\n  width: 100%;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    PublicProfileClassic_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfileClassic_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  padding-bottom: ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  img {\n    display: block;\n    height: ",
        ";\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  small {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    strong {\n      font-weight: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileClassic_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfileClassic_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  transition: color 0.2s;\n\n  &::after {\n    content: '/';\n    font-weight: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    PublicProfileClassic_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border-bottom: 1px solid transparent;\n  font-family: inherit;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  transition: 0.2s;\n  cursor: pointer;\n\n  .is-active & {\n    border-color: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Positioning.*/\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Positioning. */\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n\n  /* Color */\n  background-color: ",
        ";\n  opacity: 0.75;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c15f20c-0"
})(PublicProfileClassic_styled_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl6"));
var StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-9c15f20c-1"
})(PublicProfileClassic_styled_templateObject1(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("cyan_700"), (0,theme/* screen */.sp)("lg"), (0,theme/* color */.$_)("mint_900"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c15f20c-2"
})(PublicProfileClassic_styled_templateObject2(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-9c15f20c-3"
})(PublicProfileClassic_styled_templateObject3(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontWeight */.Ue)("black"));
var StyledNavItemNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-9c15f20c-4"
})(PublicProfileClassic_styled_templateObject4(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* color */.$_)("text_placeholder"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("text_disabled"));
var StyledNavItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c15f20c-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("text_active"), StyledNavItemNumber, (0,theme/* color */.$_)("text_active"));
var ElementsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c15f20c-6"
})(_templateObject6());
var LinkedInOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9c15f20c-7"
})(_templateObject7(), (0,theme/* color */.$_)("info_900"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/career/ClassicCVCareer.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_FROM_LINKENDIN = {
    jobs: false
};
var TIMELINE_CARD_TYPE = "career";

;// CONCATENATED MODULE: ./components/publicProfile/classic/career/ClassicCVCareer.hooks.ts



// Custom Hook
// -----------------------------------------------------------------------------
var useClassicCVCareer = function(param) {
    var timeline = param.publicManfredite.timeline;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Variables.
    // ---------------------------------------------------------------------------
    var filteredTimeline = (0,react.useMemo)(function() {
        return timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
            return e.cardType === TIMELINE_CARD_TYPE;
        });
    }, [
        timeline
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        timeline: filteredTimeline,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/career/ClassicCVCareer.tsx






// Component.
// -----------------------------------------------------------------------------
var ClassicCVCareer = function(param) {
    var _fromLinkedIn = param.fromLinkedIn, fromLinkedIn = _fromLinkedIn === void 0 ? DEFAULT_FROM_LINKENDIN : _fromLinkedIn, publicManfredite = param.publicManfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVCareer({
        publicManfredite: publicManfredite
    }), t = ref.t, timeline = ref.timeline;
    // Functions.
    // ---------------------------------------------------------------------------
    var renderCareer = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                    children: t("classic.sections.career")
                }),
                timeline === null || timeline === void 0 ? void 0 : timeline.map(function(p, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(classic_ClasicCVCard, {
                            profileItem: p,
                            index: i
                        })
                    }, i);
                })
            ]
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
        children: fromLinkedIn.jobs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
            isSection: true,
            children: renderCareer()
        }) : renderCareer()
    });
};
/* harmony default export */ var career_ClassicCVCareer = (ClassicCVCareer);

// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/publicProfile/classic/certifications/ClasicCVCertificationsCard.styled.ts

function ClasicCVCertificationsCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    display: grid;\n    grid-template-columns: 11.5rem 1fr;\n  }\n"
    ]);
    ClasicCVCertificationsCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClasicCVCertificationsCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        ";\n    border-bottom: 0;\n  }\n\n  &.no-logo {\n    display: none;\n\n    @media (min-width: ",
        ") {\n      display: flex;\n    }\n  }\n\n  img {\n    max-width: 100%;\n    max-height: ",
        ";\n    display: block;\n\n    @media (min-width: ",
        ") {\n      max-height: 7.5rem;\n    }\n  }\n"
    ]);
    ClasicCVCertificationsCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClasicCVCertificationsCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        ";\n    border-left: 1px solid ",
        ";\n  }\n"
    ]);
    ClasicCVCertificationsCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClasicCVCertificationsCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.16;\n  font-weight: ",
        ";\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    ClasicCVCertificationsCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClasicCVCertificationsCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-weight: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    ClasicCVCertificationsCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ClasicCVCertificationsCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n  max-height: 0;\n\n  &.is-active {\n    max-height: var(--content-height);\n  }\n"
    ]);
    ClasicCVCertificationsCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97f45854-0"
})(ClasicCVCertificationsCard_styled_templateObject(), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"));
var StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97f45854-1"
})(ClasicCVCertificationsCard_styled_templateObject1(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97f45854-2"
})(ClasicCVCertificationsCard_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"));
var ClasicCVCertificationsCard_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-97f45854-3"
})(ClasicCVCertificationsCard_styled_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"));
var StyledCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97f45854-4"
})(ClasicCVCertificationsCard_styled_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledExtraContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-97f45854-5"
})(ClasicCVCertificationsCard_styled_templateObject5());

;// CONCATENATED MODULE: ./components/publicProfile/classic/certifications/ClasicCVCertificationsCard.tsx












var ClasicCVCertificationsCard = function(param) {
    var profileItem = param.profileItem, index = param.index;
    var toggleContent = function toggleContent() {
        setActiveState(setActive === "" ? "is-active" : "");
    };
    var renderEllapsedTime = function renderEllapsedTime(from, to) {
        var ellapsedTime = publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(from, to, t);
        if (!ellapsedTime) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledEllapsedTime */.SM, {
            children: [
                "(",
                ellapsedTime,
                ")"
            ]
        });
    };
    var ref, ref1;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var content = (0,react.useRef)(null);
    var currentHeight = (ref = content.current) === null || ref === void 0 ? void 0 : ref.scrollHeight;
    var ref2 = (0,react.useState)(""), setActive = ref2[0], setActiveState = ref2[1];
    var contentHeight = {
        "--content-height": "".concat(currentHeight, "px")
    };
    (0,react.useEffect)(function() {
        if (index === 0) {
            setActiveState("is-active");
        }
    }, [
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLogo, {
                className: "".concat(!profileItem.logoUrl ? "no-logo" : ""),
                children: [
                    profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: profileItem.logoUrl,
                        alt: profileItem.logoAlt
                    }),
                    !profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/profile/certification.svg"),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                children: [
                    (profileItem.desc || profileItem.techs && profileItem.techs.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledTrigger */.tr, {
                        type: "button",
                        id: "button_" + profileItem.cardType + index,
                        className: "".concat(setActive),
                        onClick: toggleContent,
                        "aria-expanded": setActive === "is-active",
                        "aria-controls": "content_" + profileItem.cardType + index,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCertificationsCard_styled_StyledTitle, {
                                        as: "a",
                                        href: profileItem.link,
                                        children: profileItem.title
                                    }),
                                    !profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCertificationsCard_styled_StyledTitle, {
                                        children: profileItem.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTriggerIcon */.SO, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faAngleDown */.gc2
                                })
                            })
                        ]
                    }),
                    !profileItem.desc && profileItem.techs && profileItem.techs.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCertificationsCard_styled_StyledTitle, {
                            children: profileItem.title
                        })
                    }),
                    profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompany, {
                        children: t("issuedBy", {
                            company: profileItem.company
                        })
                    }),
                    (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDate */.Az, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                profileItem.dateInitial && profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDateRange */.zn, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                                }),
                                                profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                                })
                                            ]
                                        }),
                                        renderEllapsedTime(profileItem.dateInitial.toString(), profileItem.dateFinal.toString())
                                    ]
                                }),
                                profileItem.dateInitial && !profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDateRange */.zn, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("classic.noExpiryDate")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExtraContent, {
                        ref: content,
                        id: "content_" + profileItem.cardType + index,
                        className: "".concat(setActive),
                        style: contentHeight,
                        role: "region",
                        "aria-labelledby": "button_" + profileItem.cardType + index,
                        children: [
                            profileItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDesc */.yG, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                    content: profileItem.desc
                                })
                            }),
                            profileItem.techs && profileItem.techs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsTitle */.xD, {
                                        children: t("timeline.techs")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsList */.wy, {
                                        children: (ref1 = profileItem.techs) === null || ref1 === void 0 ? void 0 : ref1.map(function(t, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledTechsItem */.HZ, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsLogo */.hr, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: t.iconUrl,
                                                            alt: t.iconAlt
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t.name
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var certifications_ClasicCVCertificationsCard = (ClasicCVCertificationsCard);

;// CONCATENATED MODULE: ./components/publicProfile/classic/certifications/ClassicCVCertifications.tsx




var ClassicCVCertifications = function(param) {
    var timeline = param.publicManfredite.timeline;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var filteredTimeline = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.cardType === "certification";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: t("classic.sections.certifications")
            }),
            filteredTimeline === null || filteredTimeline === void 0 ? void 0 : filteredTimeline.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(certifications_ClasicCVCertificationsCard, {
                        profileItem: item,
                        index: index
                    })
                }, index);
            })
        ]
    });
};
/* harmony default export */ var certifications_ClassicCVCertifications = (ClassicCVCertifications);

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVLinkedInButton.hooks.ts



// Custom hook.
// -----------------------------------------------------------------------------
var useClassicCVLinkedInButton = function(param) {
    var onResetLinkedIn = param.onResetLinkedIn;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var router = (0,next_router.useRouter)();
    // Handlers.
    // ---------------------------------------------------------------------------
    var handleOnClick = (0,react.useCallback)(function() {
        var pathname = window.location.href.split("?")[0];
        var query = router.query;
        delete router.query.linkedin;
        delete router.query.slug;
        delete router.query.view;
        router.replace({
            pathname: pathname,
            query: query
        }, undefined, {
            shallow: true
        });
        onResetLinkedIn();
    }, [
        onResetLinkedIn,
        router
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        onClick: handleOnClick,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVLinkedInButton.styled.tsx

function ClassicCVLinkedInButton_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    bottom: -100%;\n    opacity: 0;\n  }\n  to {\n    bottom: 25%;\n    opacity: 1;\n  }\n"
    ]);
    ClassicCVLinkedInButton_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassicCVLinkedInButton_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Position */\n  right: 10%;\n  position: fixed;\n  z-index: 100;\n\n  // Others.\n  animation: ",
        " 1s ease-in-out forwards;\n"
    ]);
    ClassicCVLinkedInButton_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

// Animations.
// -----------------------------------------------------------------------------
var appear = (0,styled_components_browser_esm/* keyframes */.F4)(ClassicCVLinkedInButton_styled_templateObject());
// Styled-Components.
// -----------------------------------------------------------------------------
var ClassicCVLinkedInButtonRoot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79e1d2be-0"
})(ClassicCVLinkedInButton_styled_templateObject1(), appear);

;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVLinkedInButton.tsx





// Component.
// -----------------------------------------------------------------------------
var ClassicCVLinkedInButton = function(param) {
    var hasLinkedIn = param.hasLinkedIn, onResetLinkedIn = param.onResetLinkedIn;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVLinkedInButton({
        onResetLinkedIn: onResetLinkedIn
    }), onClick = ref.onClick, t = ref.t;
    // Guard Condition.
    // ---------------------------------------------------------------------------
    if (!hasLinkedIn) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedInButtonRoot, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zx, {
            label: t("linkedInButton"),
            startIcon: pro_solid_svg_icons/* faCheckCircle */.f8k,
            onClick: onClick
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ./components/shared/Avatar.tsx
var Avatar = __webpack_require__(6937);
// EXTERNAL MODULE: ./components/shared/Avatar.styled.tsx
var Avatar_styled = __webpack_require__(11472);
;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileComponent.styled.ts

function PublicProfileComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"
    ]);
    PublicProfileComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfileComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin: ",
        " auto;\n  width: 100%;\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin: ",
        " auto;\n  }\n"
    ]);
    PublicProfileComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfileComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    PublicProfileComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfileComponent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  transition: color 0.2s;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-bottom: 0;\n  }\n\n  &::after {\n    content: '/';\n    font-weight: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    color: ",
        ";\n\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    PublicProfileComponent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfileComponent_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  background: unset;\n  border: 0;\n  border-bottom: 1px solid transparent;\n  font-family: inherit;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: 0.2s;\n  cursor: pointer;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    padding: ",
        " ",
        ";\n  }\n\n  &.is-active {\n    border-color: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileComponent_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PublicProfileComponent_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    PublicProfileComponent_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PublicProfileComponent_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  img {\n    display: block;\n    height: ",
        ";\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  small {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    strong {\n      font-weight: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileComponent_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var StyledProfile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c681714c-0"
})(PublicProfileComponent_styled_templateObject());
var PublicProfileComponent_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c681714c-1"
})(PublicProfileComponent_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c681714c-2"
})(PublicProfileComponent_styled_templateObject2(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledTabNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c681714c-3"
})(PublicProfileComponent_styled_templateObject3(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* color */.$_)("text_placeholder"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("text_disabled"), (0,theme/* screen */.sp)("mdMax"));
var StyledTab = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c681714c-4"
})(PublicProfileComponent_styled_templateObject4(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_active"), StyledTabNumber, (0,theme/* color */.$_)("text_active"));
var StyledTabContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c681714c-5"
})(PublicProfileComponent_styled_templateObject5(), (0,theme/* container */.nC)("lg"));
var PublicProfileComponent_styled_StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-c681714c-6"
})(PublicProfileComponent_styled_templateObject6(), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVNavBar.styled.ts

function ClassicCVNavBar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: translateY(-100%);\n  transition: 0.3s;\n  width: 100%;\n  height: 4.25rem;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  box-shadow: ",
        ";\n"
    ]);
    ClassicCVNavBar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassicCVNavBar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: unset;\n      ",
        " {\n        transform: translateY(0);\n      }\n    "
    ]);
    ClassicCVNavBar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClassicCVNavBar_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  z-index: ",
        ";\n  pointer-events: none;\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    ClassicCVNavBar_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClassicCVNavBar_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    ClassicCVNavBar_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClassicCVNavBar_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n\n  ",
        " {\n    flex-shrink: 0;\n  }\n"
    ]);
    ClassicCVNavBar_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ClassicCVNavBar_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  width: 100%;\n  padding: ",
        ";\n  background-color: ",
        ";\n  position: absolute;\n  right: -100%;\n  top: 4.25rem;\n  height: calc(100vh - 4.25rem);\n  transition: right 0.3s;\n  overflow: auto;\n\n  &.is-visible {\n    right: 0;\n  }\n\n  ",
        " {\n    @media (max-width: ",
        ") {\n      flex-direction: row;\n\n      ",
        " {\n        margin-bottom: 0;\n        display: flex;\n        font-size: ",
        ";\n        &::after {\n          display: block;\n        }\n      }\n    }\n\n    @media (max-width: ",
        ") {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    }\n  }\n"
    ]);
    ClassicCVNavBar_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ClassicCVNavBar_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  background: unset;\n  border: 0;\n  margin-left: auto;\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    ClassicCVNavBar_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var StyledNavBarInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0d3d84f-0"
})(ClassicCVNavBar_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"));
var StyledNavBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0d3d84f-1"
})(ClassicCVNavBar_styled_templateObject2(), (0,theme/* zindex */.Y0)("profileNavBar"), function(param) {
    var visible = param.visible;
    return visible === true && (0,styled_components_browser_esm/* css */.iv)(ClassicCVNavBar_styled_templateObject1(), StyledNavBarInner);
}, (0,theme/* screen */.sp)("lg"));
var ClassicCVNavBar_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0d3d84f-2"
})(ClassicCVNavBar_styled_templateObject3(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0d3d84f-3"
})(ClassicCVNavBar_styled_templateObject4(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("black"), Avatar_styled/* StyledAvatar */.b);
var ClassicCVNavBar_styled_StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b0d3d84f-4"
})(ClassicCVNavBar_styled_templateObject5(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("white"), StyledTab, (0,theme/* screen */.sp)("mdMax"), StyledTabNumber, (0,theme/* fontSize */.JB)("xl2"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"));
var StyledTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b0d3d84f-5"
})(ClassicCVNavBar_styled_templateObject6(), (0,theme/* color */.$_)("midnight_300"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/ClassicCVNavBar.tsx






var ClassicCVNavBar = function(param) {
    var _publicManfredite = param.publicManfredite, avatarUrl = _publicManfredite.avatarUrl, avatarAlt = _publicManfredite.avatarAlt, firstName = _publicManfredite.firstName, lastName = _publicManfredite.lastName, visible = param.visible, children = param.children, displayMenu = param.displayMenu, displayTabs = param.displayTabs, displayTrigger = param.displayTrigger;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavBar, {
        visible: visible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavBarInner, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVNavBar_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfo, {
                        children: [
                            avatarUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                avatarImg: avatarUrl,
                                avatarAlt: avatarAlt || "",
                                sizes: "md"
                            }),
                            (firstName || lastName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            !firstName && !lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("unknownManfredite")
                            })
                        ]
                    }),
                    displayTrigger && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTrigger, {
                        onClick: function() {
                            return displayMenu();
                        },
                        children: [
                            displayTabs === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faBars */.xiG
                            }),
                            displayTabs === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faClose */.YIN
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVNavBar_styled_StyledTabs, {
                        role: "tablist",
                        "aria-label": t("tabs.title"),
                        className: "".concat(displayTabs && visible ? "is-visible" : ""),
                        children: children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var classic_ClassicCVNavBar = (ClassicCVNavBar);

;// CONCATENATED MODULE: ./components/publicProfile/classic/education/ClassicCVEducation.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var ClassicCVEducation_constants_DEFAULT_FROM_LINKENDIN = {
    educations: false
};
var CLASSIC_EDUCATION_TIMELINE_COURSE = "COURSE";
var CLASSIC_EDUCATION_TIMELINE_DEGREE = "DEGREE";
var CLASSIC_EDUCATION_TIMELINE_TRAINING = "TRAINING";

;// CONCATENATED MODULE: ./components/publicProfile/classic/PublicProfileClassic.utils.ts

// Utils.
// -----------------------------------------------------------------------------
var hasBookmarks = function(manfredite) {
    return !(0,lodash.isEmpty)(manfredite.bookmarks);
};
var hasCardType = function(manfredite, card) {
    return manfredite.timeline ? manfredite.timeline.some(function(time) {
        return time.cardType === card;
    }) : false;
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/education/ClassicCVEducation.utils.ts
// Utils.
// -----------------------------------------------------------------------------
var getTimeline = function(manfredite, type) {
    return manfredite.timeline ? manfredite.timeline.filter(function(time) {
        return time.type === type;
    }) : [];
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/education/ClassicCVEducation.hooks.ts




// Hooks.
// -----------------------------------------------------------------------------
var useClassicCVEducation = function(param) {
    var manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Variables.
    // ---------------------------------------------------------------------------
    var hasData = (0,react.useMemo)(function() {
        return hasCardType(manfredite, "education");
    }, [
        manfredite
    ]);
    var courses = (0,react.useMemo)(function() {
        return getTimeline(manfredite, "COURSE");
    }, [
        manfredite
    ]);
    var degrees = (0,react.useMemo)(function() {
        return getTimeline(manfredite, "DEGREE");
    }, [
        manfredite
    ]);
    var trainings = (0,react.useMemo)(function() {
        return getTimeline(manfredite, "SELF_TRAINING");
    }, [
        manfredite
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        courses: courses,
        degrees: degrees,
        trainings: trainings,
        hasData: hasData,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/education/ClassicCVEducation.styled.ts

function ClassicCVEducation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    font-size: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    &::before {\n      top: -",
        ";\n      width: ",
        ";\n      height: ",
        ";\n      background-color: ",
        ";\n\n      @media (min-width: ",
        ") {\n        width: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    ClassicCVEducation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledSubSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e69624-0"
})(ClassicCVEducation_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl5"), StyledTitle, (0,theme/* fontSize */.JB)("xl4"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("indigo_500"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("cyan_700"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/education/ClassicCVEducation.tsx








// Component.
// -----------------------------------------------------------------------------
var ClassicCVEducation = function(param) {
    var _fromLinkedIn = param.fromLinkedIn, fromLinkedIn = _fromLinkedIn === void 0 ? ClassicCVEducation_constants_DEFAULT_FROM_LINKENDIN : _fromLinkedIn, manfredite = param.manfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVEducation({
        manfredite: manfredite
    }), courses = ref.courses, degrees = ref.degrees, trainings = ref.trainings, hasData = ref.hasData, t = ref.t;
    // Guard clause.
    // ---------------------------------------------------------------------------
    if (!hasData) {
        return null;
    }
    var renderEducations = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                    children: t("classic.sections.education")
                }),
                !(0,lodash.isEmpty)(degrees) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            as: "h3",
                            children: t("classic.sections.degrees")
                        }),
                        degrees.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(classic_ClasicCVCard, {
                                    profileItem: item,
                                    index: index
                                })
                            }, index);
                        })
                    ]
                }),
                !(0,lodash.isEmpty)(courses) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            as: "h3",
                            children: t("classic.sections.courses")
                        }),
                        courses.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(classic_ClasicCVCard, {
                                    profileItem: item,
                                    index: index
                                })
                            }, index);
                        })
                    ]
                }),
                !(0,lodash.isEmpty)(trainings) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            as: "h3",
                            children: t("classic.sections.selfTraining")
                        }),
                        trainings.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(classic_ClasicCVCard, {
                                    profileItem: item,
                                    index: index
                                })
                            }, index);
                        })
                    ]
                })
            ]
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSection, {
        children: fromLinkedIn.educations ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
            isSection: true,
            children: renderEducations()
        }) : renderEducations()
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/education/index.ts


;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeader.constants.ts


// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_LINKEDIN_IMPORT = {
    avatar: false,
    name: false,
    position: false,
    whereDoYouLive: false
};
var LINK_ICON = {
    github: free_brands_svg_icons/* faGithub */.zhw,
    linkedIn: free_brands_svg_icons/* faLinkedin */.D9H,
    stackOverflow: free_brands_svg_icons/* faStackOverflow */.mGT,
    other: pro_solid_svg_icons/* faLink */.nNP,
    twitter: free_brands_svg_icons/* faTwitter */.mdU
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeader.styled.ts

function ClassicCVHeader_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    flex-direction: row;\n    gap: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  ",
        " {\n    width: 8rem;\n    height: 8rem;\n    flex-shrink: 0;\n\n    @media (min-width: ",
        ") {\n      width: 16rem;\n      height: 16rem;\n    }\n  }\n\n  h1 {\n    font-size: ",
        ";\n    line-height: 1.2;\n    font-weight: ",
        ";\n    margin-top: 0;\n    margin-bottom: 0;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      margin-bottom: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.125;\n    }\n  }\n"
    ]);
    ClassicCVHeader_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassicCVHeader_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.333;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.2;\n  }\n"
    ]);
    ClassicCVHeader_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClassicCVHeader_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    gap: ",
        ";\n  }\n"
    ]);
    ClassicCVHeader_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClassicCVHeader_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  min-width: 180px;\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n\n    @media (min-width: ",
        ") {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    ClassicCVHeader_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClassicCVHeader_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  display: flex;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    gap: ",
        ";\n  }\n\n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n\n    @media (min-width: ",
        ") {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    ClassicCVHeader_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-8813868d-0"
})(ClassicCVHeader_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl"), Avatar_styled/* StyledAvatar */.b, (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl3"));
var StyledIntro = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8813868d-1"
})(ClassicCVHeader_styled_templateObject1(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8813868d-2"
})(ClassicCVHeader_styled_templateObject2(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8813868d-3"
})(ClassicCVHeader_styled_templateObject3(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("emerald_600"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledSocial = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8813868d-4"
})(ClassicCVHeader_styled_templateObject4(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeaderAvatar.tsx



// Component.
// -----------------------------------------------------------------------------
var ClassicCVHeaderAvatar = function(param) {
    var linkedIn = param.linkedIn, _manfredite = param.manfredite, avatarAlt = _manfredite.avatarAlt, avatarUrl = _manfredite.avatarUrl;
    // Guard condition.
    // ---------------------------------------------------------------------------
    if (!avatarUrl) {
        return null;
    }
    // Functions.
    // ---------------------------------------------------------------------------
    var renderAvatar = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
            avatarImg: avatarUrl,
            avatarAlt: avatarAlt || "",
            sizes: "lg"
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return linkedIn.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
        children: renderAvatar()
    }) : renderAvatar();
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeaderData.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_LINKEDIN_COMBINATION = "none";

;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeaderData.hooks.ts



// Custom Hook.
// -----------------------------------------------------------------------------
var useClassicHeaderData = function(param) {
    var email = param.email, linkedIn = param.linkedIn, manfredite = param.manfredite, phone = param.phone;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = (0,react.useState)(DEFAULT_LINKEDIN_COMBINATION), combination = ref[0], setCombination = ref[1];
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Variables.
    // ---------------------------------------------------------------------------
    var hasNameInfo = (0,react.useMemo)(function() {
        return !!manfredite.firstName || !!manfredite.lastName;
    }, [
        manfredite.firstName,
        manfredite.lastName
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(function() {
        var name = linkedIn.name, position = linkedIn.position, whereDoYouLive = linkedIn.whereDoYouLive;
        // Has 'whereDoYouLive' info.
        if (whereDoYouLive) {
            if (name && position && !email && !phone) {
                setCombination("location-name-position");
            } else {
                setCombination("location-name");
            }
        // Doesn't have 'whereDoYouLive' info.
        } else {
            if (name && position) {
                setCombination("name-position");
            } else if (name) {
                setCombination("only-name");
            } else if (!name && !position) {
                setCombination("none");
            }
        }
    }, [
        email,
        linkedIn,
        phone
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        combination: combination,
        hasNameInfo: hasNameInfo,
        t: t
    };
};

// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeaderLinks.tsx





// Component.
// -----------------------------------------------------------------------------
var ClassicCVHeaderLinks = function(param) {
    var links = param.manfredite.links;
    return links ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocial, {
        children: links.map(function(link, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                content: link.desc,
                direction: "up",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: link.url,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: LINK_ICON[link.type]
                    })
                })
            }, "link_".concat(i));
        })
    }) : null;
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeaderData.tsx







// Component.
// -----------------------------------------------------------------------------
var ClassicCVHeaderData = function(param) {
    var email = param.email, linkedIn = param.linkedIn, manfredite = param.manfredite, phone = param.phone;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicHeaderData({
        email: email,
        linkedIn: linkedIn,
        manfredite: manfredite,
        phone: phone
    }), combination = ref.combination, hasNameInfo = ref.hasNameInfo, t = ref.t;
    // Helpers.
    // ---------------------------------------------------------------------------
    var renderEmailAndPhone = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
            children: [
                email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faEnvelope */.FU$
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:".concat(email),
                            children: email
                        })
                    ]
                }),
                phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faPhone */.j1w
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: phone
                        })
                    ]
                }),
                manfredite.whereDoYouLive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faMapMarkerCheck */.e8U
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: manfredite.whereDoYouLive
                        })
                    ]
                })
            ]
        });
    };
    var renderName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: hasNameInfo ? "".concat(manfredite.firstName, " ").concat(manfredite.lastName) : t("unknownManfredite")
        });
    };
    var renderPosition = function() {
        return manfredite.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntro, {
            children: manfredite.headline
        });
    };
    var renderNamePosition = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVLinkedIn, {
                    children: [
                        renderName(),
                        renderPosition()
                    ]
                }),
                renderEmailAndPhone()
            ]
        });
    };
    var renderNone = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                renderName(),
                renderPosition(),
                renderEmailAndPhone()
            ]
        });
    };
    var renderOnlyName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
                    children: renderName()
                }),
                renderPosition(),
                renderEmailAndPhone()
            ]
        });
    };
    var renderLocationNamePosition = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVLinkedIn, {
            children: [
                renderName(),
                renderPosition(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledData, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faMapMarkerCheck */.e8U
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: manfredite.whereDoYouLive
                            })
                        ]
                    })
                })
            ]
        });
    };
    var renderLocationName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
                    children: renderName()
                }),
                renderPosition(),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
                    children: [
                        email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faEnvelope */.FU$
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:".concat(email),
                                    children: email
                                })
                            ]
                        }),
                        phone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_solid_svg_icons/* faPhone */.j1w
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: phone
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedIn, {
                            firstOfRow: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faMapMarkerCheck */.e8U
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: manfredite.whereDoYouLive
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    // Return.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            combination === "location-name-position" && renderLocationNamePosition(),
            combination === "location-name" && renderLocationName(),
            combination === "name-position" && renderNamePosition(),
            combination === "none" && renderNone(),
            combination === "only-name" && renderOnlyName(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVHeaderLinks, {
                manfredite: manfredite
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/header/ClassicCVHeader.tsx





// Component.
// -----------------------------------------------------------------------------
var ClassicCVHeader = function(param) {
    var email = param.email, _linkedIn = param.linkedIn, linkedIn = _linkedIn === void 0 ? DEFAULT_LINKEDIN_IMPORT : _linkedIn, phone = param.phone, manfredite = param.manfredite;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVHeaderAvatar, {
                linkedIn: linkedIn,
                manfredite: manfredite
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVHeaderData, {
                email: email,
                linkedIn: linkedIn,
                manfredite: manfredite,
                phone: phone
            })
        ]
    });
};
/* harmony default export */ var header_ClassicCVHeader = (ClassicCVHeader);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./components/publicProfile/shared/CVFilter.tsx + 1 modules
var CVFilter = __webpack_require__(97561);
// EXTERNAL MODULE: ../../node_modules/react-reveal/Fade.js
var Fade = __webpack_require__(24647);
var Fade_default = /*#__PURE__*/__webpack_require__.n(Fade);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.tsx
var BadgeFlag = __webpack_require__(67489);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.styled.ts
var BadgeFlag_styled = __webpack_require__(66859);
;// CONCATENATED MODULE: ./components/publicProfile/classic/highlights/ClasicCVHighlightCard.styled.ts

function ClasicCVHighlightCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  border-radius: 0 ",
        " ",
        " 0;\n  border: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  border-bottom: 1px solid ",
        ";\n  border-top-right-radius: ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    border-bottom: 0;\n    border-right: 1px solid ",
        ";\n    border-top-right-radius: 0;\n    width: 20rem;\n    flex-shrink: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    width: 30rem;\n  }\n\n  img {\n    width: 100%;\n    height: 100%;\n    max-width: unset !important;\n    margin-top: 0;\n    object-fit: cover;\n    display: block;\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0 ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    border-top-right-radius: ",
        ";\n    padding: 0 ",
        " ",
        " ",
        ";\n  }\n\n  &:last-child {\n    border-bottom-right-radius: ",
        ";\n  }\n\n  ",
        " {\n    margin-left: calc(-",
        " + -",
        ");\n    transform: translateY(-50%);\n\n    @media (min-width: ",
        ") {\n      margin-left: calc(-",
        " + -",
        ");\n      margin-top: -1px;\n      margin-bottom: ",
        ";\n      transform: unset;\n    }\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:first-child {\n    ",
        " {\n      border-top-right-radius: ",
        ";\n    }\n  }\n  @media (min-width: ",
        ") {\n    flex-grow: 1;\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        ";\n    flex-grow: 1;\n  }\n\n  ",
        " {\n    padding-top: 0;\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.16;\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ClasicCVHighlightCard_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n  max-height: 0;\n\n  &.is-active {\n    max-height: var(--content-height);\n  }\n"
    ]);
    ClasicCVHighlightCard_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  display: flex;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.25;\n  }\n\n  a {\n    font-weight: ",
        ";\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    word-break: break-word;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var ClasicCVHighlightCard_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-0"
})(ClasicCVHighlightCard_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"));
var StyledHighlightImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-1"
})(ClasicCVHighlightCard_styled_templateObject1(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("lg"));
var ClasicCVHighlightCard_styled_StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-2"
})(ClasicCVHighlightCard_styled_templateObject2(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("lg"), BadgeFlag_styled/* StyledFlag */.O, (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"));
var ClasicCVHighlightCard_styled_StyledInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-3"
})(ClasicCVHighlightCard_styled_templateObject3(), ClasicCVHighlightCard_styled_StyledLogo, (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("md"));
var ClasicCVHighlightCard_styled_StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-4"
})(ClasicCVHighlightCard_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), ClasicCVCard_styled/* StyledDesc */.yG);
var ClasicCVHighlightCard_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-a597d810-5"
})(ClasicCVHighlightCard_styled_templateObject5(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"));
var ClasicCVHighlightCard_styled_StyledCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-6"
})(ClasicCVHighlightCard_styled_templateObject6(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("medium"));
var ClasicCVHighlightCard_styled_StyledExtraContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-7"
})(ClasicCVHighlightCard_styled_templateObject7());
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a597d810-8"
})(_templateObject8(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/highlights/ClasicCVHighlightCard.tsx










var ClasicCVHighlightCard = function(param) {
    var profileItem = param.profileItem;
    var getItemTypeText = function getItemTypeText(item) {
        if (item.cardType === "highlight") {
            return (item.type ? t("timeline.type.highlight.".concat(item.type)) : "") + (item.category ? ": ".concat(item.category) : "");
        }
        return "";
    };
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var text = getItemTypeText(profileItem);
    var typeIcons = {
        POST: pro_solid_svg_icons/* faNewspaper */.Xgz,
        TALK: pro_solid_svg_icons/* faKeynote */.XH,
        LAUNCH: free_solid_svg_icons/* faRocket */.tMT,
        MILESTONE: pro_solid_svg_icons/* faBadgeCheck */.fix,
        VIDEO: pro_solid_svg_icons/* faFilmAlt */.QRc,
        AWARD: pro_solid_svg_icons/* faMedal */._su
    };
    var typeColors = {
        LAUNCH: "dark2_03",
        MILESTONE: "set1_02",
        TALK: "set1_05",
        VIDEO: "set1_04",
        POST: "set1_03",
        AWARD: "set1_07"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVHighlightCard_styled_StyledCard, {
        children: [
            profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlightImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: profileItem.logoUrl,
                    alt: profileItem.logoAlt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVHighlightCard_styled_StyledInfo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVHighlightCard_styled_StyledLogo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeFlag/* default */.Z, {
                                color: typeColors[profileItem.type || "TALK"],
                                icon: typeIcons[profileItem.type || "TALK"],
                                text: text
                            }),
                            profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVHighlightCard_styled_StyledTitle, {
                                as: "a",
                                href: profileItem.link,
                                children: profileItem.title
                            }),
                            !profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVHighlightCard_styled_StyledTitle, {
                                children: profileItem.title
                            }),
                            (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDate */.Az, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: profileItem.dateSingle && !profileItem.dateInitial && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateSingle, locale)
                                    })
                                })
                            }),
                            profileItem.cardType === "project" && profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: profileItem.logoUrl,
                                alt: profileItem.logoAlt
                            })
                        ]
                    }),
                    (profileItem.desc || profileItem.link || profileItem.techs && profileItem.techs.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVHighlightCard_styled_StyledContent, {
                        children: [
                            profileItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDesc */.yG, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsTitle */.xD, {
                                        children: t("description")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                        content: profileItem.desc
                                    })
                                ]
                            }),
                            profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("url"),
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: profileItem.link,
                                        children: profileItem.link
                                    })
                                ]
                            }),
                            profileItem.techs && profileItem.techs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsTitle */.xD, {
                                        children: t("timeline.techs")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsList */.wy, {
                                        children: (ref = profileItem.techs) === null || ref === void 0 ? void 0 : ref.map(function(t, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledTechsItem */.HZ, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsLogo */.hr, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: t.iconUrl,
                                                            alt: t.iconAlt
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t.name
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var highlights_ClasicCVHighlightCard = (ClasicCVHighlightCard);

// EXTERNAL MODULE: ./components/publicProfile/classic/highlights/ClassicCVHighlights.styled.ts
var ClassicCVHighlights_styled = __webpack_require__(10655);
;// CONCATENATED MODULE: ./components/publicProfile/classic/highlights/ClassicCVHighlights.tsx










var ClassicCVHighlights = function(param) {
    var timeline = param.publicManfredite.timeline;
    var highlights = (timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.cardType === "highlight";
    })) || [];
    var shouldShowFilter = highlights.length > 8;
    var filters = (0,_to_consumable_array/* default */.Z)(new Set(highlights.map(function(highlight) {
        return highlight.type;
    })));
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var ref = (0,react.useState)(""), activeFilter = ref[0], setActiveFilter = ref[1];
    var handleOnFilterChange = function(newFilter) {
        setActiveFilter(newFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTitle */.X0, {
                children: t("classic.sections.highlights")
            }),
            shouldShowFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(CVFilter/* default */.Z, {
                onFilterChange: handleOnFilterChange,
                filters: filters,
                filterTranslationPrefix: "timeline.type.highlight"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVHighlights_styled/* StyledCards */.h, {
                children: timeline === null || timeline === void 0 ? void 0 : timeline.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: item.cardType === "highlight" && (item.type === activeFilter || activeFilter === "") && /*#__PURE__*/ (0,jsx_runtime.jsx)((Fade_default()), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_ClasicCVHighlightCard, {
                                profileItem: item
                            })
                        })
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var highlights_ClassicCVHighlights = (ClassicCVHighlights);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjectCard.constants.ts


// Constants.
// -----------------------------------------------------------------------------
var DEFAULT_TYPE = "TALK";
var ICONS = {
    LAUNCH: {
        color: "dark2_03",
        icon: free_solid_svg_icons/* faRocket */.tMT
    },
    MILESTONE: {
        color: "set1_02",
        icon: pro_solid_svg_icons/* faBadgeCheck */.fix
    },
    OPEN_SOURCE: {
        color: "set2_04",
        icon: pro_solid_svg_icons/* faFileCode */.w49
    },
    POST: {
        color: "set1_03",
        icon: pro_solid_svg_icons/* faNewspaper */.Xgz
    },
    SIDE_PROJECT: {
        color: "set1_05",
        icon: pro_solid_svg_icons/* faBookSpells */.W9J
    },
    TALK: {
        color: "set1_05",
        icon: pro_solid_svg_icons/* faKeynote */.XH
    },
    VIDEO: {
        color: "set1_04",
        icon: pro_solid_svg_icons/* faFilmAlt */.QRc
    }
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjectCard.utils.tsx




// Utils.
// -----------------------------------------------------------------------------
var getItemType = function(item) {
    return item.cardType === "project" || item.cardType === "highlight" ? item.type : DEFAULT_TYPE;
};
var getIcon = function(item) {
    return ICONS[getItemType(item)];
};
var getItemTypeText = function(item, t) {
    if (item.cardType === "project") {
        if (!item.type) {
            return "";
        }
        return t("timeline.type.project.".concat(item.type));
    }
    if (item.cardType === "highlight") {
        return (item.type ? t("timeline.type.highlight.".concat(item.type)) : "") + (item.category ? ": ".concat(item.category) : "");
    }
    return "";
};
var renderEllapsedTime = function(param) {
    var from = param.from, t = param.t, to = param.to;
    var ellapsedTime = publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(from, to, t);
    if (!ellapsedTime) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledEllapsedTime */.SM, {
        children: [
            "(",
            ellapsedTime,
            ")"
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjectCard.hooks.ts




// Custom Hook.
// -----------------------------------------------------------------------------
var useClassicCVProjectCard = function(param) {
    var profileItem = param.profileItem;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,next_router.useRouter)().locale;
    // Variables.
    // ---------------------------------------------------------------------------
    var icon = (0,react.useMemo)(function() {
        return getIcon(profileItem);
    }, [
        profileItem
    ]);
    var text = (0,react.useMemo)(function() {
        return getItemTypeText(profileItem, t);
    }, [
        profileItem,
        t
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        icon: icon,
        locale: locale,
        t: t,
        text: text
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjectCard.styled.ts

function ClassicCVProjectCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: grid;\n    grid-template-columns: 16rem 1fr;\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 20rem 1fr;\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  border-top-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    border-bottom-left-radius: ",
        ";\n    border-top-right-radius: 0;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n    border-bottom: 0;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    margin-top: ",
        ";\n\n    @media (min-width: ",
        ") {\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -",
        ";\n  margin-left: -",
        ";\n  margin-right: -",
        ";\n  margin-bottom: ",
        ";\n  border-top-right-radius: ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    margin-top: -",
        ";\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n    margin-bottom: ",
        ";\n\n    border-top-right-radius: 0;\n  }\n\n  img {\n    width: 100%;\n    max-width: unset !important;\n    margin-top: 0;\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        " {\n    position: absolute;\n    top: -",
        ";\n    left: -",
        ";\n    transform: translateY(-50%);\n\n    @media (min-width: ",
        ") {\n      top: -",
        ";\n      left: -",
        ";\n    }\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  @media (min-width: ",
        ") {\n    border-left: 1px solid ",
        ";\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    padding-top: 0;\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.16;\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    ClassicCVProjectCard_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n  max-height: 0;\n\n  &.is-active {\n    max-height: var(--content-height);\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ClassicCVProjectCard_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  display: flex;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.25;\n  }\n\n  a {\n    font-weight: ",
        ";\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    word-break: break-word;\n  }\n"
    ]);
    ClassicCVProjectCard_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var ClassicCVProjectCard_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-0"
})(ClassicCVProjectCard_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var ClassicCVProjectCard_styled_StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-1"
})(ClassicCVProjectCard_styled_templateObject1(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var ClassicCVProjectCard_styled_StyledHighlightImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-2"
})(ClassicCVProjectCard_styled_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"));
var StyledFlagContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-3"
})(ClassicCVProjectCard_styled_templateObject3(), BadgeFlag_styled/* StyledFlag */.O, (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"));
var ClassicCVProjectCard_styled_StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-4"
})(ClassicCVProjectCard_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("xl"), ClasicCVCard_styled/* StyledDesc */.yG);
var ClassicCVProjectCard_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-98c9818d-5"
})(ClassicCVProjectCard_styled_templateObject5(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"));
var ClassicCVProjectCard_styled_StyledCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-6"
})(ClassicCVProjectCard_styled_templateObject6(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("medium"));
var ClassicCVProjectCard_styled_StyledExtraContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-7"
})(ClassicCVProjectCard_styled_templateObject7());
var ClassicCVProjectCard_styled_StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-98c9818d-8"
})(ClassicCVProjectCard_styled_templateObject8(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjectCard.tsx










// Component.
// -----------------------------------------------------------------------------
var ClassicCVProjectCard = function(param) {
    var profileItem = param.profileItem;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVProjectCard({
        profileItem: profileItem
    }), icon = ref.icon, locale = ref.locale, t = ref.t, text = ref.text;
    // Helpers.
    // ---------------------------------------------------------------------------
    var renderDates = function() {
        return profileItem.dateInitial || profileItem.dateSingle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDate */.Az, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    profileItem.dateInitial && profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDateRange */.zn, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                    })
                                ]
                            }),
                            renderEllapsedTime({
                                from: profileItem.dateInitial.toString(),
                                t: t,
                                to: profileItem.dateFinal.toString()
                            })
                        ]
                    }),
                    profileItem.dateInitial && !profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDateRange */.zn, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("timeline.today")
                                    })
                                ]
                            }),
                            renderEllapsedTime({
                                from: profileItem.dateInitial.toString(),
                                t: t,
                                to: new Date().toString()
                            })
                        ]
                    }),
                    profileItem.dateSingle && !profileItem.dateInitial && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateSingle, locale)
                    })
                ]
            })
        });
    };
    var renderDesc = function() {
        return profileItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledDesc */.yG, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsTitle */.xD, {
                    children: t("description")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                    content: profileItem.desc
                })
            ]
        });
    };
    var renderImage = function() {
        return profileItem.cardType === "project" && profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: profileItem.logoUrl,
            alt: profileItem.logoAlt
        });
    };
    var renderLink = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVProjectCard_styled_StyledLink, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        t("url"),
                        ":"
                    ]
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: profileItem.link,
                    children: profileItem.link
                })
            ]
        });
    };
    var renderTechs = function() {
        var ref;
        return profileItem.techs && profileItem.techs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsTitle */.xD, {
                    children: t("timeline.techs")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsList */.wy, {
                    children: (ref = profileItem.techs) === null || ref === void 0 ? void 0 : ref.map(function(t, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClasicCVCard_styled/* StyledTechsItem */.HZ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledTechsLogo */.hr, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: t.iconUrl,
                                        alt: t.iconAlt
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t.name
                                })
                            ]
                        }, i);
                    })
                })
            ]
        });
    };
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVProjectCard_styled_StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVProjectCard_styled_StyledLogo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlagContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeFlag/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icon), {
                                text: text
                            })),
                            profileItem.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVProjectCard_styled_StyledTitle, {
                                as: "a",
                                href: profileItem.link,
                                children: profileItem.title
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVProjectCard_styled_StyledTitle, {
                                children: profileItem.title
                            })
                        ]
                    }),
                    renderDates(),
                    renderImage()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClassicCVProjectCard_styled_StyledContent, {
                children: [
                    renderDesc(),
                    renderLink(),
                    renderTechs()
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjects.hooks.ts
// Custom hook.


// -----------------------------------------------------------------------------
var useClassicCVProjects = function(param) {
    var publicManfredite = param.publicManfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    // Variables.
    // ---------------------------------------------------------------------------
    var projects = (0,react.useMemo)(function() {
        return publicManfredite.timeline ? publicManfredite.timeline.filter(function(item) {
            return item.cardType === "project";
        }) : [];
    }, [
        publicManfredite.timeline
    ]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        projects: projects,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/ClassicCVProjects.tsx





// Component.
// -----------------------------------------------------------------------------
var ClassicCVProjects = function(param) {
    var publicManfredite = param.publicManfredite;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = useClassicCVProjects({
        publicManfredite: publicManfredite
    }), projects = ref.projects, t = ref.t;
    // Guard clause.
    // ---------------------------------------------------------------------------
    if ((0,lodash.isEmpty)(projects)) {
        return null;
    }
    // Render
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: t("classic.sections.projects")
            }),
            projects.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVProjectCard, {
                        profileItem: item
                    })
                }, index);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/projects/index.ts


;// CONCATENATED MODULE: ./components/publicProfile/classic/PublicProfileClassic.constants.ts
// Constants.
// -----------------------------------------------------------------------------
var QS_AVATAR = "profilePhoto";
var QS_INTRODUCTION = "aboutMe";
var QS_JOBS = "jobPositions";
var QS_LANGUAGES = "languages";
var QS_NAME = "name";
var QS_POSITION = "headline";
var QS_SKILLS = "technologies";
var QS_EDUCATIONS = "educations";
var QS_WHERE_DO_YOU_LIVE = "location";
var PublicProfileClassic_constants_DEFAULT_LINKEDIN_IMPORT = {
    avatar: false,
    introduction: false,
    jobs: false,
    languages: false,
    name: false,
    position: false,
    technologies: false,
    educations: false,
    whereDoYouLive: false
};
var DEFAULT_PROFILE_DATA = {
    bookmarks: false,
    career: false,
    certifications: false,
    education: false,
    highlights: false,
    projects: false
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/PublicProfileClassic.hook.ts





// Custom Hook.
// -----------------------------------------------------------------------------
var usePublicProfileClassic = function(param) {
    var manfredite = param.manfredite, setHasLinkedInQuery = param.setHasLinkedInQuery;
    // Hooks.
    // ---------------------------------------------------------------------------
    var ref = (0,react.useState)(false), displayNavBar = ref[0], setDisplayNavBar = ref[1];
    var ref1 = (0,react.useState)(false), displayTabs = ref1[0], setDisplayTabs = ref1[1];
    var ref2 = (0,react.useState)(DEFAULT_PROFILE_DATA), hasData = ref2[0], setHasData = ref2[1];
    var ref3 = (0,react.useState)(PublicProfileClassic_constants_DEFAULT_LINKEDIN_IMPORT), linkedIn = ref3[0], setLinkedIn = ref3[1];
    var ref4 = (0,react.useState)([]), sections = ref4[0], setSections = ref4[1];
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,next_router.useRouter)().locale;
    var query = (0,next_router.useRouter)().query;
    // Handlers.
    // ---------------------------------------------------------------------------
    var handleOnDisplayMenu = (0,react.useCallback)(function() {
        if (displayTabs === false) {
            var ref;
            (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.add("mobile-scroll-blocked");
        } else {
            var ref1;
            (ref1 = document.querySelector("body")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("mobile-scroll-blocked");
        }
        setDisplayTabs(!displayTabs);
    }, [
        displayTabs
    ]);
    var handleOnCloseMenu = (0,react.useCallback)(function() {
        var ref;
        setDisplayTabs(false);
        (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.remove("mobile-scroll-blocked");
    }, []);
    var handleResetLinkedIn = (0,react.useCallback)(function() {
        if (setHasLinkedInQuery) {
            setHasLinkedInQuery(false);
        }
        setLinkedIn(PublicProfileClassic_constants_DEFAULT_LINKEDIN_IMPORT);
    }, [
        setHasLinkedInQuery
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react.useEffect)(function() {
        if (query.linkedin) {
            var newLinkedIn = {
                avatar: query.linkedin.includes(QS_AVATAR),
                introduction: query.linkedin.includes(QS_INTRODUCTION),
                jobs: query.linkedin.includes(QS_JOBS),
                languages: query.linkedin.includes(QS_LANGUAGES),
                name: query.linkedin.includes(QS_NAME),
                position: query.linkedin.includes(QS_POSITION),
                technologies: query.linkedin.includes(QS_SKILLS),
                educations: query.linkedin.includes(QS_EDUCATIONS),
                whereDoYouLive: query.linkedin.includes(QS_WHERE_DO_YOU_LIVE)
            };
            setLinkedIn(newLinkedIn);
        }
    }, [
        query.linkedin
    ]);
    // Profile data.
    (0,react.useEffect)(function() {
        setHasData({
            bookmarks: hasBookmarks(manfredite),
            career: hasCardType(manfredite, "career"),
            certifications: hasCardType(manfredite, "certification"),
            education: hasCardType(manfredite, "education"),
            highlights: hasCardType(manfredite, "highlight"),
            projects: hasCardType(manfredite, "project")
        });
    }, [
        manfredite
    ]);
    // Sections.
    (0,react.useEffect)(function() {
        var newSections = [
            {
                section: "about",
                tooltip: t("classic.sections.aboutMe")
            }
        ];
        if (hasData) {
            // Bookmarks.
            if (hasData.bookmarks) {
                newSections.push({
                    section: "bookmarks",
                    tooltip: t("classic.sections.bookmarks")
                });
            }
            // Career.
            if (hasData.career) {
                newSections.push({
                    section: "career",
                    tooltip: t("classic.sections.career")
                });
            }
            // Certifications.
            if (hasData.certifications) {
                newSections.push({
                    section: "certifications",
                    tooltip: t("classic.sections.certifications")
                });
            }
            // Education.
            if (hasData.education) {
                newSections.push({
                    section: "education",
                    tooltip: t("classic.sections.education")
                });
            }
            // Highlights.
            if (hasData.highlights) {
                newSections.push({
                    section: "highlights",
                    tooltip: t("classic.sections.highlights")
                });
            }
            // Projects.
            if (hasData.projects) {
                newSections.push({
                    section: "projects",
                    tooltip: t("classic.sections.projects")
                });
            }
        }
        setSections(newSections);
    }, [
        hasData,
        t
    ]);
    // Display nav bar.
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (window.scrollY > 100) {
                setDisplayNavBar(true);
            } else {
                setDisplayNavBar(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        displayNavBar: displayNavBar,
        displayTabs: displayTabs,
        hasData: hasData,
        hasLinkedIn: Object.values(linkedIn).some(function(value) {
            return value;
        }),
        linkedIn: linkedIn,
        locale: locale,
        sections: sections,
        onCloseMenu: handleOnCloseMenu,
        onDisplayMenu: handleOnDisplayMenu,
        onResetLinkedIn: handleResetLinkedIn,
        t: t
    };
};

;// CONCATENATED MODULE: ./components/publicProfile/classic/PublicProfileClassic.tsx



















// Component.
// -----------------------------------------------------------------------------
var PublicProfileClassic = function(param) {
    var manfredite = param.manfredite, setHasLinkedInQuery = param.setHasLinkedInQuery;
    var ref = usePublicProfileClassic({
        manfredite: manfredite,
        setHasLinkedInQuery: setHasLinkedInQuery
    }), displayNavBar = ref.displayNavBar, displayTabs = ref.displayTabs, hasData = ref.hasData, hasLinkedIn = ref.hasLinkedIn, linkedIn = ref.linkedIn, locale = ref.locale, onCloseMenu = ref.onCloseMenu, onDisplayMenu = ref.onDisplayMenu, onResetLinkedIn = ref.onResetLinkedIn, sections = ref.sections, t = ref.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        noTopBar: true,
        noFooter: true,
        pageVariant: "classicProfile",
        sections: sections,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVLinkedInButton, {
                hasLinkedIn: hasLinkedIn,
                onResetLinkedIn: onResetLinkedIn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(classic_ClassicCVNavBar, {
                publicManfredite: manfredite,
                visible: displayNavBar,
                displayMenu: onDisplayMenu,
                displayTabs: displayTabs && !(0,lodash.isEmpty)(sections),
                displayTrigger: !(0,lodash.isEmpty)(sections),
                children: sections.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                        activeClass: "is-active",
                        to: item.section,
                        href: "#".concat(item.section),
                        spy: true,
                        onClick: onCloseMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavItemNumber, {
                                    children: [
                                        "0",
                                        index + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.tooltip
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ElementsWrapper, {
                children: [
                    hasLinkedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedInOverlay, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modules/* Element */.W_, {
                                name: "about_me",
                                id: "about",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header_ClassicCVHeader, {
                                        email: manfredite.email,
                                        linkedIn: linkedIn,
                                        manfredite: manfredite,
                                        phone: manfredite.phoneNumber
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAbout, {
                                        fromLinkedIn: linkedIn,
                                        manfredite: manfredite
                                    })
                                ]
                            }),
                            hasData.career && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "career",
                                id: "career",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(career_ClassicCVCareer, {
                                    fromLinkedIn: linkedIn,
                                    publicManfredite: manfredite
                                })
                            }),
                            hasData.education && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "education",
                                id: "education",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVEducation, {
                                    fromLinkedIn: linkedIn,
                                    manfredite: manfredite
                                })
                            }),
                            hasData.certifications && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "certifications",
                                id: "certifications",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(certifications_ClassicCVCertifications, {
                                    publicManfredite: manfredite
                                })
                            }),
                            hasData.projects && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "projects",
                                id: "projects",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVProjects, {
                                    publicManfredite: manfredite
                                })
                            }),
                            hasData.highlights && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "highlights",
                                id: "highlights",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_ClassicCVHighlights, {
                                    publicManfredite: manfredite
                                })
                            }),
                            hasData.bookmarks && /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                name: "bookmarks",
                                id: "bookmarks",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                            children: t("classic.sections.bookmarks")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CVBookmarks/* default */.Z, {
                                            publicManfredite: manfredite
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("footer.poweredBy")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.home */.uu.home, locale),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: logos/* LOGO_MANFRED */.$q,
                                                alt: "Manfred Tech"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                        children: [
                                            "\xa9 ",
                                            new Date().getFullYear(),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Manfred Tech"
                                            }),
                                            " ",
                                            "S.L."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var classic_PublicProfileClassic = (PublicProfileClassic);


/***/ }),

/***/ 94252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PP": function() { return /* binding */ StyledSection; },
/* harmony export */   "X0": function() { return /* binding */ StyledTitle; },
/* harmony export */   "XX": function() { return /* binding */ StyledSubSection; },
/* harmony export */   "em": function() { return /* binding */ StyledShowMore; },
/* harmony export */   "qY": function() { return /* binding */ StyledText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n\n  .masonry-grid {\n    display: flex;\n    margin-left: -",
        "; /* gutter size offset */\n    width: auto;\n  }\n  .masonry-column {\n    padding-left: ",
        "; /* gutter size */\n    background-clip: padding-box;\n\n    &.is-full-width {\n      width: 100% !important;\n    }\n\n    &:empty {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -",
        ";\n    left: 0;\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n\n    @media (min-width: ",
        ") {\n      width: ",
        ";\n      height: ",
        ";\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n\n  &:not(.display-full-text) {\n    display: -webkit-box;\n    -webkit-line-clamp: 12;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ul {\n    padding-left: 1em;\n  }\n\n  li {\n    list-style: disc;\n    &:not(:first-child) {\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  position: relative;\n  width: 100%;\n\n  button {\n    padding: 0;\n    background: transparent;\n    border: 0;\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    cursor: pointer;\n  }\n\n  svg {\n    flex-shrink: 0;\n    width: 1.25rem !important;\n    height: 1.25rem;\n    color: ",
        ";\n  }\n\n  span {\n    flex-shrink: 0;\n    color: ",
        ";\n    font-weight: ",
        ";\n    text-transform: uppercase;\n    font-size: ",
        ";\n    line-height: 1;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  &::after {\n    content: '';\n    flex-grow: 1;\n    height: 1px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-50e2d76d-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl5"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl6"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl5"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl5"));
var StyledSubSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-50e2d76d-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-50e2d76d-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("display"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("light"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
var StyledText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-50e2d76d-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"));
var StyledShowMore = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-50e2d76d-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("link"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));


/***/ }),

/***/ 10655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ StyledCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledCards = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2599240b-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"));


/***/ }),

/***/ 32162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdf_PublicProfilePdfComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-qrcode-logo/dist/index.js
var dist = __webpack_require__(35716);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/config.ts
var config = __webpack_require__(75339);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ./services/ui/publicprofile/publicprofile.service.ts
var publicprofile_service = __webpack_require__(27595);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/publicProfile/pdf/about-me/PdfCVAbout.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8.47mm;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12pt;\n  line-height: 1.25;\n  font-weight: ",
        ";\n  margin-top: 0;\n  margin-bottom: 2.12mm;\n  page-break-after: avoid;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.6;\n  font-size: 7.5pt;\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ul {\n    padding-left: 1em;\n  }\n\n  li {\n    list-style: disc;\n    &:not(:first-child) {\n      margin-top: 1em;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 2.65mm;\n  font-size: 7.5pt;\n  font-weight: ",
        ";\n  line-height: 1.16;\n\n  &:not(:last-child) {\n    margin-bottom: 2.12mm;\n  }\n\n  img {\n    width: 6.35mm;\n    height: 6.35mm;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2.12mm;\n  font-size: 9pt;\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  padding-bottom: 0.53mm;\n  border-bottom: 0.26mm solid ",
        ";\n  page-break-after: avoid;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  page-break-before: avoid;\n  li {\n    display: inline-block;\n    font-size: 7.5pt;\n    line-height: 1.15;\n    font-weight: ",
        ";\n  }\n\n  li:not(:last-child) {\n    &::after {\n      content: '/';\n      margin-left: 1.06mm;\n      margin-right: 1.06mm;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledSubSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b2099ca-0"
})(_templateObject());
var StyledTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-7b2099ca-1"
})(_templateObject1(), (0,theme/* fontWeight */.Ue)("black"));
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b2099ca-2"
})(_templateObject2());
var StyledSkill = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b2099ca-3"
})(_templateObject3(), (0,theme/* fontWeight */.Ue)("medium"));
var StyledTechsTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-7b2099ca-4"
})(_templateObject4(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("midnight_300"));
var StyledTechsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7b2099ca-5"
})(_templateObject5(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_placeholder"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/about-me/PdfCVAbout.tsx





var PdfCVAboutMarkdownContent = function(param) {
    var title = param.title, content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                    content: content
                })
            })
        ]
    });
};
var ClassicCVAboutTechs = function(param) {
    var title = param.title, techs = param.techs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsList, {
                children: techs.map(function(t, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: t.name
                    }, i);
                })
            })
        ]
    });
};
var PdfCVAbout = function(param) {
    var publicManfredite = param.publicManfredite;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var intro = publicManfredite.intro, bestPractices = publicManfredite.bestPractices, softSkills = publicManfredite.softSkills, techs = publicManfredite.techs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: publicprofile_service/* default.hasGeneralInfo */.Z.hasGeneralInfo(publicManfredite) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                intro && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVAboutMarkdownContent, {
                    title: t("about.introduction"),
                    content: intro
                }),
                softSkills && softSkills.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: t("about.skills")
                        }),
                        softSkills.map(function(s, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkill, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: s.iconUrl,
                                        alt: s.iconAlt,
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: s.name
                                    })
                                ]
                            }, i);
                        })
                    ]
                }),
                !!(bestPractices === null || bestPractices === void 0 ? void 0 : bestPractices.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVAboutMarkdownContent, {
                    title: t("about.bestPractices"),
                    content: bestPractices
                }),
                publicprofile_service/* default.hasAnyTech */.Z.hasAnyTech(publicManfredite) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                            children: t("about.techs.title")
                        }),
                        (techs === null || techs === void 0 ? void 0 : techs.master) && (techs === null || techs === void 0 ? void 0 : techs.master.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVAboutTechs, {
                            title: t("about.techs.master"),
                            techs: techs.master
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var about_me_PdfCVAbout = (PdfCVAbout);

// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(3716);
;// CONCATENATED MODULE: ./components/publicProfile/pdf/PdfCVCard.styled.ts

function PdfCVCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 6.36mm;\n  padding-left: 6.36mm;\n  page-break-inside: avoid;\n\n  &:not(:last-child) {\n    padding-bottom: 6.36mm;\n    border-bottom: 0.26mm solid ",
        ";\n  }\n"
    ]);
    PdfCVCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 4.23mm;\n\n  img {\n    max-height: 8.47mm;\n    display: block;\n    padding-right: 2.65mm;\n    margin-right: 2.65mm;\n    border-right: 0.26mm solid ",
        ";\n  }\n"
    ]);
    PdfCVCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PdfCVCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12pt;\n  line-height: 1.25;\n  font-weight: ",
        ";\n"
    ]);
    PdfCVCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PdfCVCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10.5pt;\n  line-height: 1.14;\n  font-weight: ",
        ";\n  margin: 0;\n  position: relative;\n\n  &::before {\n    content: '';\n    width: 4.23mm;\n    height: 0;\n    border-top: 0.26mm solid ",
        ";\n    position: absolute;\n    left: -6.36mm;\n    top: 2.21mm;\n  }\n"
    ]);
    PdfCVCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PdfCVCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.06mm;\n  font-size: 7.5pt;\n  line-height: 1.14;\n  font-weight: ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.06mm;\n"
    ]);
    PdfCVCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PdfCVCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > :first-child::after {\n    content: ' — ';\n    color: ",
        ";\n  }\n"
    ]);
    PdfCVCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4.23mm;\n  font-size: 7.5pt;\n  line-height: 1.6;\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ul,\n  ol {\n    margin-left: 4.23mm;\n    margin-top: 4.23mm;\n  }\n\n  ul li {\n    list-style-type: disc;\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n\n  ul + p,\n  ol + p {\n    margin-top: 4.23mm;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-size: 7.25pt;\n  line-height: 1.14;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  margin-top: 4.23mm;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  li {\n    display: inline-block;\n    font-size: 7.5pt;\n    line-height: 1.15;\n    font-weight: ",
        ";\n  }\n\n  li:not(:last-child) {\n    &::after {\n      content: '/';\n      margin-left: 1.06mm;\n      margin-right: 1.06mm;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ddaed3-0"
})(PdfCVCard_styled_templateObject(), (0,theme/* color */.$_)("midnight_200"));
var StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ddaed3-1"
})(PdfCVCard_styled_templateObject1(), (0,theme/* color */.$_)("midnight_200"));
var StyledCompany = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c4ddaed3-2"
})(PdfCVCard_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("medium"));
var PdfCVCard_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-c4ddaed3-3"
})(PdfCVCard_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_200"));
var StyledDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ddaed3-4"
})(PdfCVCard_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledDateRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ddaed3-5"
})(PdfCVCard_styled_templateObject5(), (0,theme/* color */.$_)("text_default"));
var StyledEllapsedTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c4ddaed3-6"
})(_templateObject6(), (0,theme/* fontWeight */.Ue)("medium"));
var StyledDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ddaed3-7"
})(_templateObject7());
var PdfCVCard_styled_StyledTechsTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c4ddaed3-8"
})(_templateObject8(), (0,theme/* fontWeight */.Ue)("extraBold"));
var PdfCVCard_styled_StyledTechsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c4ddaed3-9"
})(_templateObject9(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_placeholder"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/PdfCVCard.tsx







var PdfCVCard = function(param) {
    var profileItem = param.profileItem;
    var renderEllapsedTime = function renderEllapsedTime(from, to) {
        var ellapsedTime = publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(from, to, t);
        if (!ellapsedTime) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEllapsedTime, {
            children: [
                "(",
                ellapsedTime,
                ")"
            ]
        });
    };
    var ref;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,client_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLogo, {
                children: [
                    profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: profileItem.logoUrl,
                        alt: profileItem.logoAlt
                    }),
                    profileItem.link && profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompany, {
                        href: profileItem.link,
                        children: profileItem.company
                    }),
                    !profileItem.link && profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCompany, {
                        as: "span",
                        children: profileItem.company
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCard_styled_StyledTitle, {
                children: profileItem.title
            }),
            (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDate, {
                children: [
                    profileItem.dateInitial && profileItem.dateFinal && !(0,date/* isSameDateYearAndMonth */.jm)(profileItem.dateInitial, profileItem.dateFinal) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                    })
                                ]
                            }),
                            renderEllapsedTime(profileItem.dateInitial.toString(), profileItem.dateFinal.toString())
                        ]
                    }),
                    profileItem.dateInitial && profileItem.dateFinal && (0,date/* isSameDateYearAndMonth */.jm)(profileItem.dateInitial, profileItem.dateFinal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                    }),
                    profileItem.dateInitial && !profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("timeline.today")
                                    })
                                ]
                            }),
                            renderEllapsedTime(profileItem.dateInitial.toString(), new Date().toString())
                        ]
                    })
                ]
            }),
            profileItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                    content: profileItem.desc
                })
            }),
            profileItem.techs && profileItem.techs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCard_styled_StyledTechsTitle, {
                        children: t("timeline.techs")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCard_styled_StyledTechsList, {
                        children: (ref = profileItem.techs) === null || ref === void 0 ? void 0 : ref.map(function(t, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: t.name
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pdf_PdfCVCard = (PdfCVCard);

;// CONCATENATED MODULE: ./components/publicProfile/pdf/career/PdfCVCareer.styled.ts

function PdfCVCareer_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.27cm;\n"
    ]);
    PdfCVCareer_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVCareer_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 21pt;\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: 6.35mm;\n  position: relative;\n  page-break-after: avoid;\n\n  strong {\n    font-weight: ",
        ";\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: -2.12mm;\n    left: 0;\n    width: 1.27cm;\n    height: 0;\n    border-top: 1.06mm solid ",
        ";\n  }\n"
    ]);
    PdfCVCareer_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df96492-0"
})(PdfCVCareer_styled_templateObject());
var PdfCVCareer_styled_StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-df96492-1"
})(PdfCVCareer_styled_templateObject1(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* fontWeight */.Ue)("semibold"), (0,theme/* color */.$_)("midnight_300"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/career/PdfCVCareer.tsx




var PdfCVCareer = function(param) {
    var timeline = param.publicManfredite.timeline;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var filteredTimeline = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.cardType === "career";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCareer_styled_StyledTitle, {
                children: [
                    t("classic.sections.experience"),
                    "/",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: t("classic.sections.career")
                    })
                ]
            }),
            filteredTimeline === null || filteredTimeline === void 0 ? void 0 : filteredTimeline.map(function(p, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(pdf_PdfCVCard, {
                    profileItem: p
                }, i);
            })
        ]
    });
};
/* harmony default export */ var career_PdfCVCareer = (PdfCVCareer);

// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/publicProfile/pdf/education/PdfCVCertificationsCard.styled.ts

function PdfCVCertificationsCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4.23mm;\n  border-radius: 4.23mm;\n  border: 0.26mm solid ",
        ";\n  overflow: hidden;\n  display: flex;\n  page-break-inside: avoid;\n"
    ]);
    PdfCVCertificationsCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVCertificationsCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.54cm;\n  background-color: ",
        ";\n  padding: 4.23mm;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    max-width: 100%;\n    max-height: 1.69cm;\n    display: block;\n  }\n"
    ]);
    PdfCVCertificationsCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PdfCVCertificationsCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6.35mm 4.23mm;\n  border-left: 0.26mm solid ",
        ";\n"
    ]);
    PdfCVCertificationsCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PdfCVCertificationsCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10.5pt;\n  line-height: 1.14;\n  font-weight: ",
        ";\n  margin: 0;\n"
    ]);
    PdfCVCertificationsCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PdfCVCertificationsCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.06mm;\n  font-weight: ",
        ";\n  font-size: 7.5pt;\n  line-height: 1.2;\n"
    ]);
    PdfCVCertificationsCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var PdfCVCertificationsCard_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8e00230-0"
})(PdfCVCertificationsCard_styled_templateObject(), (0,theme/* color */.$_)("midnight_200"));
var PdfCVCertificationsCard_styled_StyledLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8e00230-1"
})(PdfCVCertificationsCard_styled_templateObject1(), (0,theme/* color */.$_)("midnight_100"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8e00230-2"
})(PdfCVCertificationsCard_styled_templateObject2(), (0,theme/* color */.$_)("midnight_200"));
var PdfCVCertificationsCard_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-e8e00230-3"
})(PdfCVCertificationsCard_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("extraBold"));
var PdfCVCertificationsCard_styled_StyledCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e8e00230-4"
})(PdfCVCertificationsCard_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/education/PdfCVCertificationsCard.tsx








var PdfCVCertificationsCard = function(param) {
    var profileItem = param.profileItem;
    var renderEllapsedTime = function renderEllapsedTime(from, to) {
        var ellapsedTime = publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(from, to, t);
        if (!ellapsedTime) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEllapsedTime, {
            children: [
                "(",
                ellapsedTime,
                ")"
            ]
        });
    };
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,client_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCertificationsCard_styled_StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCertificationsCard_styled_StyledLogo, {
                children: [
                    profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: profileItem.logoUrl,
                        alt: profileItem.logoAlt
                    }),
                    !profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/profile/certification.svg"),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                children: [
                    profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCertificationsCard_styled_StyledTitle, {
                        as: "a",
                        href: profileItem.link,
                        children: profileItem.title
                    }),
                    !profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCertificationsCard_styled_StyledTitle, {
                        children: profileItem.title
                    }),
                    profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCertificationsCard_styled_StyledCompany, {
                        children: t("issuedBy", {
                            company: profileItem.company
                        })
                    }),
                    (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDate, {
                        children: [
                            profileItem.dateInitial && profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                            }),
                                            profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                            })
                                        ]
                                    }),
                                    renderEllapsedTime(profileItem.dateInitial.toString(), profileItem.dateFinal.toString())
                                ]
                            }),
                            profileItem.dateInitial && !profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("timeline.today")
                                            })
                                        ]
                                    }),
                                    renderEllapsedTime(profileItem.dateInitial.toString(), new Date().toString())
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var education_PdfCVCertificationsCard = (PdfCVCertificationsCard);

;// CONCATENATED MODULE: ./components/publicProfile/pdf/education/PdfCVCourseCard.styled.ts

function PdfCVCourseCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4.23mm;\n  padding-left: 6.36mm;\n  page-break-inside: avoid;\n"
    ]);
    PdfCVCourseCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVCourseCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n"
    ]);
    PdfCVCourseCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PdfCVCourseCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 9pt;\n  line-height: 1.33;\n  font-weight: ",
        ";\n  margin: 0;\n  position: relative;\n\n  &::before {\n    content: '';\n    width: 4.23mm;\n    height: 0;\n    border-top: 0.26mm solid ",
        ";\n    position: absolute;\n    left: -6.36mm;\n    top: 2.21mm;\n  }\n"
    ]);
    PdfCVCourseCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PdfCVCourseCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.06mm;\n  font-size: 7.5pt;\n  line-height: 1.14;\n  font-weight: ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.06mm;\n"
    ]);
    PdfCVCourseCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PdfCVCourseCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > :first-child::after {\n    content: ' — ';\n    color: ",
        ";\n  }\n"
    ]);
    PdfCVCourseCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PdfCVCourseCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  white-space: nowrap;\n"
    ]);
    PdfCVCourseCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var PdfCVCourseCard_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-362eb61-0"
})(PdfCVCourseCard_styled_templateObject());
var PdfCVCourseCard_styled_StyledCompany = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-362eb61-1"
})(PdfCVCourseCard_styled_templateObject1(), (0,theme/* fontWeight */.Ue)("medium"));
var PdfCVCourseCard_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-362eb61-2"
})(PdfCVCourseCard_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("midnight_200"));
var PdfCVCourseCard_styled_StyledDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-362eb61-3"
})(PdfCVCourseCard_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("extraBold"));
var PdfCVCourseCard_styled_StyledDateRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-362eb61-4"
})(PdfCVCourseCard_styled_templateObject4(), (0,theme/* color */.$_)("text_default"));
var PdfCVCourseCard_styled_StyledEllapsedTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-362eb61-5"
})(PdfCVCourseCard_styled_templateObject5(), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/education/PdfCVCourseCard.tsx






var PdfCVCourseCard = function(param) {
    var profileItem = param.profileItem;
    var renderEllapsedTime = function renderEllapsedTime(from, to) {
        var ellapsedTime = publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(from, to, t);
        if (!ellapsedTime) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCourseCard_styled_StyledEllapsedTime, {
            children: [
                "(",
                ellapsedTime,
                ")"
            ]
        });
    };
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,client_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCourseCard_styled_StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCourseCard_styled_StyledTitle, {
                children: [
                    profileItem.title,
                    profileItem.link && profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCourseCard_styled_StyledCompany, {
                                href: profileItem.link,
                                children: profileItem.company
                            })
                        ]
                    }),
                    !profileItem.link && profileItem.company && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            ", ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVCourseCard_styled_StyledCompany, {
                                as: "span",
                                children: profileItem.company
                            })
                        ]
                    })
                ]
            }),
            (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCourseCard_styled_StyledDate, {
                children: [
                    profileItem.dateInitial && profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCourseCard_styled_StyledDateRange, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                    })
                                ]
                            }),
                            renderEllapsedTime(profileItem.dateInitial.toString(), profileItem.dateFinal.toString())
                        ]
                    }),
                    profileItem.dateInitial && !profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCourseCard_styled_StyledDateRange, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("timeline.today")
                                    })
                                ]
                            }),
                            renderEllapsedTime(profileItem.dateInitial.toString(), new Date().toString())
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var education_PdfCVCourseCard = (PdfCVCourseCard);

;// CONCATENATED MODULE: ./components/publicProfile/pdf/education/PdfCVEducation.styled.ts

function PdfCVEducation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.27cm;\n"
    ]);
    PdfCVEducation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVEducation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 6.35mm;\n\n  h3 {\n    font-size: 12pt;\n    font-weight: ",
        ";\n    margin-top: 0;\n    margin-bottom: 6.35mm;\n    page-break-after: avoid;\n  }\n"
    ]);
    PdfCVEducation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PdfCVEducation_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 1.06mm;\n  margin-bottom: 1.27cm;\n\n  span {\n    color: ",
        ";\n    font-size: 7.5pt;\n    line-height: 1;\n  }\n\n  svg {\n    width: 4.23mm !important;\n    height: 4.23mm;\n    color: ",
        ";\n  }\n"
    ]);
    PdfCVEducation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var PdfCVEducation_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89dbfe4d-0"
})(PdfCVEducation_styled_templateObject());
var PdfCVEducation_styled_StyledSubSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-89dbfe4d-1"
})(PdfCVEducation_styled_templateObject1(), (0,theme/* fontWeight */.Ue)("black"));
var StyledShowMore = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-89dbfe4d-2"
})(PdfCVEducation_styled_templateObject2(), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("emerald_600"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/education/PdfCVEducation.tsx










var PdfCVEducation = function(param) {
    var timeline = param.publicManfredite.timeline, publicProfileUrl = param.publicProfileUrl;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var SHOW_MORE_THRESHOLD = 5;
    var totalEducationShowMore = SHOW_MORE_THRESHOLD * 2;
    var filteredDegrees = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.type === "DEGREE";
    });
    var filteredCoursesTraining = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.type === "COURSE" || e.type === "SELF_TRAINING";
    });
    var filteredCertifications = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.cardType === "certification";
    });
    var totalFilteredEducation = filteredDegrees === null || filteredDegrees === void 0 ? void 0 : filteredDegrees.concat(filteredCoursesTraining || []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVEducation_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCareer_styled_StyledTitle, {
                children: [
                    t("classic.sections.education"),
                    "/",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: t("classic.sections.degrees")
                    })
                ]
            }),
            filteredDegrees && (filteredDegrees === null || filteredDegrees === void 0 ? void 0 : filteredDegrees.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVEducation_styled_StyledSubSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: t("classic.sections.degrees")
                    }),
                    filteredDegrees === null || filteredDegrees === void 0 ? void 0 : filteredDegrees.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: index < SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsx)(pdf_PdfCVCard, {
                                profileItem: item
                            })
                        }, index);
                    })
                ]
            }),
            filteredCoursesTraining && (filteredCoursesTraining === null || filteredCoursesTraining === void 0 ? void 0 : filteredCoursesTraining.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVEducation_styled_StyledSubSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            t("classic.sections.courses"),
                            " &",
                            " ",
                            t("classic.sections.selfTraining")
                        ]
                    }),
                    filteredCoursesTraining === null || filteredCoursesTraining === void 0 ? void 0 : filteredCoursesTraining.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: index < SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsx)(education_PdfCVCourseCard, {
                                profileItem: item
                            })
                        }, index);
                    })
                ]
            }),
            totalFilteredEducation && totalFilteredEducation.length >= totalEducationShowMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShowMore, {
                href: publicProfileUrl,
                target: "_blank",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("pdf.moreEducations", {
                            total: totalFilteredEducation.length - totalEducationShowMore
                        })
                    })
                ]
            }),
            filteredCertifications && (filteredCertifications === null || filteredCertifications === void 0 ? void 0 : filteredCertifications.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVEducation_styled_StyledSubSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: t("classic.sections.certifications")
                    }),
                    filteredCertifications === null || filteredCertifications === void 0 ? void 0 : filteredCertifications.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: index < SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsx)(education_PdfCVCertificationsCard, {
                                profileItem: item
                            })
                        }, index);
                    })
                ]
            }),
            filteredCertifications && filteredCertifications.length >= SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShowMore, {
                href: publicProfileUrl,
                target: "_blank",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("pdf.moreCertifications", {
                            total: filteredCertifications.length - SHOW_MORE_THRESHOLD
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var education_PdfCVEducation = (PdfCVEducation);

;// CONCATENATED MODULE: ./components/publicProfile/pdf/highlights/PdfCVHighlightItem.styled.ts

function PdfCVHighlightItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 6.36mm;\n  page-break-inside: avoid;\n\n  ",
        " {\n    position: relative;\n    padding-left: 6.36mm;\n\n    &::before {\n      content: '';\n      width: 4.23mm;\n      height: 0.26mm;\n      background-color: ",
        ";\n      position: absolute;\n      left: 0;\n      top: 1.06mm;\n    }\n  }\n"
    ]);
    PdfCVHighlightItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVHighlightItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 7.5pt;\n  line-height: 1.2;\n  font-weight: ",
        ";\n  margin: 0;\n  display: inline-block;\n"
    ]);
    PdfCVHighlightItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PdfCVHighlightItem_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca78640a-0"
})(PdfCVHighlightItem_styled_templateObject(), StyledDate, (0,theme/* color */.$_)("midnight_200"));
var PdfCVHighlightItem_styled_StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-ca78640a-1"
})(PdfCVHighlightItem_styled_templateObject1(), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/highlights/PdfCVHighlightItem.tsx





var PdfCVHighlightItem = function(param) {
    var profileItem = param.profileItem;
    var locale = (0,client_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVHighlightItem_styled_StyledCard, {
        children: [
            profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVHighlightItem_styled_StyledTitle, {
                as: "a",
                href: profileItem.link,
                children: profileItem.title
            }),
            !profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfCVHighlightItem_styled_StyledTitle, {
                children: profileItem.title
            }),
            profileItem.dateSingle && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDate, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateSingle, locale)
                })
            })
        ]
    });
};
/* harmony default export */ var highlights_PdfCVHighlightItem = (PdfCVHighlightItem);

;// CONCATENATED MODULE: ./components/publicProfile/pdf/highlights/PdfCVHighlights.styled.ts

function PdfCVHighlights_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.27cm;\n  display: flex;\n  gap: 8.47mm;\n\n  > div {\n    width: 50%;\n  }\n"
    ]);
    PdfCVHighlights_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PdfCVHighlights_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e652b98b-0"
})(PdfCVHighlights_styled_templateObject());

;// CONCATENATED MODULE: ./components/publicProfile/pdf/highlights/PdfCVHighlights.tsx









var PdfCVHighlights = function(param) {
    var timeline = param.publicManfredite.timeline, publicProfileUrl = param.publicProfileUrl;
    var SHOW_MORE_THRESHOLD = 5;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var filteredPosts = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.type === "POST";
    });
    var filteredAwards = timeline === null || timeline === void 0 ? void 0 : timeline.filter(function(e) {
        return e.type === "AWARD";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVHighlights_styled_StyledSection, {
        children: [
            filteredAwards && filteredAwards.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCareer_styled_StyledTitle, {
                        children: [
                            t("classic.sections.highlights"),
                            "/",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("classic.sections.awards")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: filteredAwards === null || filteredAwards === void 0 ? void 0 : filteredAwards.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: index < SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_PdfCVHighlightItem, {
                                    profileItem: item
                                })
                            }, index);
                        })
                    }),
                    filteredAwards && filteredAwards.length >= SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShowMore, {
                        href: publicProfileUrl,
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("pdf.moreHighlights", {
                                    total: filteredAwards.length - SHOW_MORE_THRESHOLD
                                })
                            })
                        ]
                    })
                ]
            }),
            filteredPosts && filteredPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PdfCVCareer_styled_StyledTitle, {
                        children: [
                            t("classic.sections.highlights"),
                            "/",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("classic.sections.publications")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: filteredPosts === null || filteredPosts === void 0 ? void 0 : filteredPosts.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: index < SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_PdfCVHighlightItem, {
                                    profileItem: item
                                })
                            }, index);
                        })
                    }),
                    filteredPosts && filteredPosts.length >= SHOW_MORE_THRESHOLD && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShowMore, {
                        href: publicProfileUrl,
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("pdf.morePublications", {
                                    total: filteredPosts.length - SHOW_MORE_THRESHOLD
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var highlights_PdfCVHighlights = (PdfCVHighlights);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
// EXTERNAL MODULE: ./components/shared/Avatar.tsx
var Avatar = __webpack_require__(6937);
// EXTERNAL MODULE: ./components/shared/levelLadder/LevelLadder.tsx
var LevelLadder = __webpack_require__(18962);
// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
// EXTERNAL MODULE: ./components/shared/Avatar.styled.tsx
var Avatar_styled = __webpack_require__(11472);
;// CONCATENATED MODULE: ./components/publicProfile/pdf/PdfCVHeader.styled.ts

function PdfCVHeader_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-width: 4.34cm;\n\n  ",
        " {\n    width: 3.175cm;\n    height: 3.175cm;\n    flex-shrink: 0;\n  }\n"
    ]);
    PdfCVHeader_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 0.26mm solid ",
        ";\n  padding-bottom: 3.7mm;\n  margin-bottom: 3.7mm;\n\n  h1 {\n    font-size: 15pt;\n    line-height: 1.2;\n    font-weight: ",
        ";\n    margin-top: 3.175mm;\n    margin-bottom: 2.112mm;\n  }\n"
    ]);
    PdfCVHeader_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 9pt;\n  line-height: 1.333;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  margin: 0;\n"
    ]);
    PdfCVHeader_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 7.5pt;\n  line-height: 1.2;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  margin-top: 0;\n  margin-bottom: 1.05mm;\n"
    ]);
    PdfCVHeader_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 2.65mm;\n  border-bottom: 0.26mm solid ",
        ";\n  padding-bottom: 3.7mm;\n  margin-bottom: 3.7mm;\n"
    ]);
    PdfCVHeader_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 1.06mm;\n  font-size: 7.5pt;\n  word-break: break-word;\n\n  svg {\n    color: ",
        ";\n    width: 3.175mm !important;\n    height: 3.175mm;\n  }\n\n  img {\n    width: 3.175mm;\n  }\n"
    ]);
    PdfCVHeader_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 6.35mm;\n  font-size: 9pt;\n  font-weight: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    PdfCVHeader_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > span {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    gap: ",
        ";\n    margin-bottom: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n"
    ]);
    PdfCVHeader_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PdfCVHeader_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 9pt;\n  font-weight: ",
        ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n"
    ]);
    PdfCVHeader_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-9104c320-0"
})(PdfCVHeader_styled_templateObject(), Avatar_styled/* StyledAvatar */.b);
var StyledName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9104c320-1"
})(PdfCVHeader_styled_templateObject1(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontWeight */.Ue)("black"));
var StyledIntro = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9104c320-2"
})(PdfCVHeader_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("medium"));
var StyledSectionTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9104c320-3"
})(PdfCVHeader_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("medium"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9104c320-4"
})(PdfCVHeader_styled_templateObject4(), (0,theme/* color */.$_)("midnight_200"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9104c320-5"
})(PdfCVHeader_styled_templateObject5(), (0,theme/* color */.$_)("emerald_600"));
var StyledLanguages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9104c320-6"
})(PdfCVHeader_styled_templateObject6(), (0,theme/* fontWeight */.Ue)("extraBold"), StyledTitle, (0,theme/* spacing */.W0)("md"));
var StyledLanguagesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9104c320-7"
})(PdfCVHeader_styled_templateObject7(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9104c320-8"
})(PdfCVHeader_styled_templateObject8(), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/PdfCVHeader.tsx











var PdfCVHeader = function(param) {
    var _hasPublicProfile = param.hasPublicProfile, hasPublicProfile = _hasPublicProfile === void 0 ? false : _hasPublicProfile, publicProfileUrl = param.publicProfileUrl, _publicManfredite = param.publicManfredite, avatarUrl = _publicManfredite.avatarUrl, avatarAlt = _publicManfredite.avatarAlt, firstName = _publicManfredite.firstName, lastName = _publicManfredite.lastName, headline = _publicManfredite.headline, whereDoYouLive = _publicManfredite.whereDoYouLive, links = _publicManfredite.links, email = _publicManfredite.email, phoneNumber = _publicManfredite.phoneNumber, languages = _publicManfredite.languages;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var renderLinks = function(links) {
        var icons = {
            twitter: free_brands_svg_icons/* faTwitter */.mdU,
            github: free_brands_svg_icons/* faGithub */.zhw,
            stackOverflow: free_brands_svg_icons/* faStackOverflow */.mGT,
            linkedIn: free_brands_svg_icons/* faLinkedin */.D9H,
            other: pro_solid_svg_icons/* faLink */.nNP
        };
        var trimmedUrl = function(url, type) {
            if (type === "other") {
                return url.replace(/\/$/, "").replace(/^https?:\/\//, "");
            } else {
                return url.replace(/\/$/, "").split("/").pop();
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionTitle, {
                    children: t("classic.sections.myLinks")
                }),
                links.map(function(l, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        as: "a",
                        href: l.url,
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: icons[l.type]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: trimmedUrl(l.url, l.type)
                            })
                        ]
                    }, "link_".concat(i));
                }),
                hasPublicProfile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                    as: "a",
                    href: publicProfileUrl,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/isotype-manfred-green.svg"),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: trimmedUrl(publicProfileUrl, "other")
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
        children: [
            avatarUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                avatarImg: avatarUrl,
                avatarAlt: avatarAlt || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledName, {
                children: [
                    (firstName || lastName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        children: [
                            firstName,
                            " ",
                            lastName
                        ]
                    }),
                    !firstName && !lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: t("unknownManfredite")
                    }),
                    headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntro, {
                        children: headline
                    })
                ]
            }),
            (email || phoneNumber || whereDoYouLive) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionTitle, {
                        children: t("classic.sections.contact")
                    }),
                    email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faEnvelope */.FU$
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:".concat(email),
                                children: email
                            })
                        ]
                    }),
                    phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faPhone */.j1w
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: phoneNumber
                            })
                        ]
                    }),
                    whereDoYouLive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_solid_svg_icons/* faMapMarkerCheck */.e8U
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: whereDoYouLive
                            })
                        ]
                    })
                ]
            }),
            links && renderLinks(links),
            languages && languages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLanguages, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: t("about.languages")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguagesList, {
                        children: languages.map(function(l, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: l.name
                                    }),
                                    l.level !== "not-defined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelLadder/* default */.Z, {
                                        level: model/* LANGUAGES_LEVELS.indexOf */.TV.indexOf(l.level),
                                        useImage: true
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pdf_PdfCVHeader = (PdfCVHeader);

;// CONCATENATED MODULE: ./components/publicProfile/pdf/PublicProfilePdfComponent.styled.ts

function PublicProfilePdfComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: 210mm;\n  width: 100%;\n  padding: 6.35mm;\n"
    ]);
    PublicProfilePdfComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfilePdfComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8.47mm;\n"
    ]);
    PublicProfilePdfComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfilePdfComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1.27cm;\n  padding: 4.76mm;\n  border-radius: 4.23mm;\n  border: 0.026mm solid ",
        ";\n  display: flex;\n  gap: 3.18mm;\n  font-size: 7.5pt;\n  page-break-inside: avoid;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    PublicProfilePdfComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfilePdfComponent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.33cm;\n  height: 2.33cm;\n  canvas {\n    width: 100% !important;\n    max-width: 100%;\n    height: auto !important;\n  }\n"
    ]);
    PublicProfilePdfComponent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfilePdfComponent_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  font-size: 12pt;\n  line-height: 1.25;\n  margin-top: 0;\n  margin-bottom: 1.06mm;\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    PublicProfilePdfComponent_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PublicProfilePdfComponent_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 1.06mm;\n  font-weight: ",
        ";\n  margin-top: 2.12mm;\n\n  a {\n    font-weight: ",
        ";\n  }\n\n  svg {\n    width: 4.23mm !important;\n    height: 4.23mm;\n    color: ",
        ";\n  }\n"
    ]);
    PublicProfilePdfComponent_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bbd9a6e-0"
})(PublicProfilePdfComponent_styled_templateObject());
var PublicProfilePdfComponent_styled_StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bbd9a6e-1"
})(PublicProfilePdfComponent_styled_templateObject1());
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bbd9a6e-2"
})(PublicProfilePdfComponent_styled_templateObject2(), (0,theme/* color */.$_)("midnight_200"));
var StyledQR = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bbd9a6e-3"
})(PublicProfilePdfComponent_styled_templateObject3());
var StyledFooterTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-4bbd9a6e-4"
})(PublicProfilePdfComponent_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledFooterLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bbd9a6e-5"
})(PublicProfilePdfComponent_styled_templateObject5(), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("emerald_600"));

;// CONCATENATED MODULE: ./components/publicProfile/pdf/PublicProfilePdfComponent.tsx

















var PublicProfilePdfComponent = function(param) {
    var publicManfredite = param.publicManfredite, isProfileHidden = param.isProfileHidden;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var printed = (0,react.useRef)(false);
    var PRINT_DELAY_IN_MILLIS = 1500;
    var hasCareer = publicManfredite.timeline && publicManfredite.timeline.filter(function(e) {
        return e.cardType === "career";
    }).length > 0;
    var hasEducation = publicManfredite.timeline && publicManfredite.timeline.filter(function(e) {
        return e.cardType === "education";
    }).length > 0;
    var hasCertifications = publicManfredite.timeline && publicManfredite.timeline.filter(function(e) {
        return e.cardType === "certification";
    }).length > 0;
    var hasHighlights = publicManfredite.timeline && publicManfredite.timeline.filter(function(e) {
        return e.cardType === "highlight" && (e.type === "AWARD" || e.type === "POST");
    }).length > 0;
    var hasPublicProfile = !isProfileHidden;
    var publicProfileUrl = publicManfredite.slug ? (0,app_urls/* getPublicProfileUrl */.zF)({
        slug: publicManfredite.slug,
        locale: locale
    }) : "".concat(config/* config.appUrl */.v.appUrl).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.profilePreview */.uu.profilePreview, locale));
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var queryParams = new URLSearchParams(window.location.search);
            var print = queryParams.get("print") === "true";
            if (print && !printed.current) {
                printed.current = true;
                window.print();
            }
        }, PRINT_DELAY_IN_MILLIS);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        noTopBar: true,
        noFooter: true,
        pageVariant: "classicProfile",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PublicProfilePdfComponent_styled_StyledIntro, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pdf_PdfCVHeader, {
                            publicManfredite: publicManfredite,
                            publicProfileUrl: publicProfileUrl,
                            hasPublicProfile: hasPublicProfile
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(about_me_PdfCVAbout, {
                            publicManfredite: publicManfredite
                        })
                    ]
                }),
                hasCareer && /*#__PURE__*/ (0,jsx_runtime.jsx)(career_PdfCVCareer, {
                    publicManfredite: publicManfredite
                }),
                (hasEducation || hasCertifications) && /*#__PURE__*/ (0,jsx_runtime.jsx)(education_PdfCVEducation, {
                    publicManfredite: publicManfredite,
                    publicProfileUrl: publicProfileUrl
                }),
                hasHighlights && /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_PdfCVHighlights, {
                    publicManfredite: publicManfredite,
                    publicProfileUrl: publicProfileUrl
                }),
                hasPublicProfile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQR, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.QRCode, {
                                value: publicProfileUrl,
                                quietZone: 0
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooterTitle, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        ns: "publicProfile",
                                        i18nKey: "pdf.qrCode.title",
                                        components: {
                                            strong: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
                                            br: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("pdf.qrCode.desc")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooterLink, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                                ns: "publicProfile",
                                                i18nKey: "pdf.qrCode.link",
                                                components: {
                                                    profileLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: publicProfileUrl,
                                                        target: "_blank",
                                                        rel: "noreferrer"
                                                    })
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var pdf_PublicProfilePdfComponent = (PublicProfilePdfComponent);


/***/ }),

/***/ 45625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_CVBookmarks; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(97000);
// EXTERNAL MODULE: ../../node_modules/react-reveal/Fade.js
var Fade = __webpack_require__(24647);
var Fade_default = /*#__PURE__*/__webpack_require__.n(Fade);
// EXTERNAL MODULE: ./components/publicProfile/classic/highlights/ClassicCVHighlights.styled.ts
var ClassicCVHighlights_styled = __webpack_require__(10655);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.tsx
var BadgeFlag = __webpack_require__(67489);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./components/publicProfile/classic/ClasicCVCard.styled.ts
var ClasicCVCard_styled = __webpack_require__(98583);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.styled.ts
var BadgeFlag_styled = __webpack_require__(66859);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/publicProfile/shared/CVBookmarkCard.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  margin-bottom: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  padding: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.125;\n  font-weight: ",
        ";\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  strong {\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: -",
        ";\n  margin-left: -",
        ";\n  margin-right: -",
        ";\n  margin-bottom: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-top-left-radius: ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    margin-top: -",
        ";\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  img {\n    width: 100%;\n    max-width: unset !important;\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        " {\n    position: absolute;\n    top: -",
        ";\n    left: -",
        ";\n    transform: translateY(-50%);\n\n    @media (min-width: ",
        ") {\n      left: -",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  margin-top: ",
        ";\n  padding-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  display: flex;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.25;\n  }\n\n  a {\n    font-weight: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81a034c1-0"
})(_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("white"));
var StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-81a034c1-1"
})(_templateObject1(), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl2"));
var StyledAuthor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81a034c1-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_default"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("md"));
var StyledBookmarkImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81a034c1-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"));
var StyledFlagContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81a034c1-4"
})(_templateObject4(), BadgeFlag_styled/* StyledFlag */.O, (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81a034c1-5"
})(_templateObject5(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/publicProfile/shared/CVBookmarkCard.tsx







var CVBookmarkCard = function(param) {
    var bookmarkItem = param.bookmarkItem;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var typeIcons = {
        WEBSITE: pro_solid_svg_icons/* faBrowser */.m6E,
        READING: pro_solid_svg_icons/* faBook */.FL8,
        PODCAST: pro_solid_svg_icons/* faPodcast */.tb9,
        VIDEO: pro_solid_svg_icons/* faFilmAlt */.QRc,
        OTHER: pro_solid_svg_icons/* faBoxHeart */.mMr
    };
    var typeColors = {
        VIDEO: "pastel1_04",
        WEBSITE: "pastel1_06",
        READING: "pastel1_02",
        PODCAST: "pastel1_03",
        OTHER: "pastel1_05"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        children: [
            bookmarkItem.logoURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBookmarkImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: bookmarkItem.logoURL,
                    alt: bookmarkItem.logoAlt || ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlagContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeFlag/* default */.Z, {
                        color: typeColors[bookmarkItem.type || "OTHER"],
                        icon: typeIcons[bookmarkItem.type || "OTHER"],
                        text: t("timeline.type.bookmark.".concat(bookmarkItem.type))
                    }),
                    bookmarkItem.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: bookmarkItem.url,
                            children: bookmarkItem.title
                        })
                    }),
                    !bookmarkItem.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                        children: bookmarkItem.title
                    })
                ]
            }),
            bookmarkItem.author && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAuthor, {
                children: [
                    t("author"),
                    ": ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: bookmarkItem.author
                    })
                ]
            }),
            bookmarkItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClasicCVCard_styled/* StyledDesc */.yG, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                    content: bookmarkItem.desc
                })
            }),
            bookmarkItem.url && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            t("url"),
                            ":"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: bookmarkItem.url,
                        target: "_blank",
                        rel: "noreferrer",
                        children: bookmarkItem.url
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_CVBookmarkCard = (CVBookmarkCard);

;// CONCATENATED MODULE: ./components/publicProfile/shared/CVBookmarks.styled.ts

function CVBookmarks_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .masonry-grid {\n    display: flex;\n    margin-left: -",
        "; /* gutter size offset */\n    width: auto;\n  }\n  .masonry-column {\n    padding-left: ",
        "; /* gutter size */\n    background-clip: padding-box;\n\n    &:empty {\n      display: none;\n    }\n  }\n"
    ]);
    CVBookmarks_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledCVBookmarks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ebd67e-0"
})(CVBookmarks_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"));

// EXTERNAL MODULE: ./components/publicProfile/shared/CVFilter.tsx + 1 modules
var CVFilter = __webpack_require__(97561);
;// CONCATENATED MODULE: ./components/publicProfile/shared/CVBookmarks.tsx









var CVBookmarks = function(param) {
    var bookmarks = param.publicManfredite.bookmarks;
    var ref = (0,react.useState)(""), activeFilter = ref[0], setActiveFilter = ref[1];
    var shouldShowFilter = bookmarks && bookmarks.length > 8;
    var filters = (0,_to_consumable_array/* default */.Z)(new Set(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.map(function(bookmark) {
        return bookmark.type;
    })));
    var bookmarksColumns = {
        default: 2,
        671: 1
    };
    var handleOnFilterChange = function(newFilter) {
        setActiveFilter(newFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCVBookmarks, {
        children: [
            shouldShowFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(CVFilter/* default */.Z, {
                onFilterChange: handleOnFilterChange,
                filters: filters,
                filterTranslationPrefix: "timeline.type.bookmark"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicCVHighlights_styled/* StyledCards */.h, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                    breakpointCols: bookmarksColumns,
                    className: "masonry-grid",
                    columnClassName: "masonry-column",
                    children: bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: (item.type === activeFilter || activeFilter === "") && /*#__PURE__*/ (0,jsx_runtime.jsx)((Fade_default()), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_CVBookmarkCard, {
                                    bookmarkItem: item
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var shared_CVBookmarks = (CVBookmarks);


/***/ }),

/***/ 97561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_CVFilter; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/publicProfile/shared/CVFilter.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border-radius: 0;\n  border: 0;\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    color: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (max-width: ",
        ") {\n    display: none;\n    position: fixed;\n    inset: 0;\n    background-color: ",
        ";\n    padding: 0 ",
        " ",
        ";\n    margin: ",
        ";\n    border: 0;\n    box-shadow: ",
        ";\n    z-index: ",
        ";\n    overflow: hidden;\n    flex-direction: column;\n\n    &.is-open {\n      display: flex;\n    }\n  }\n\n  strong {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: 0 -",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n\n  button {\n    flex-shrink: 0;\n    margin-left: auto;\n    background: transparent;\n    border: 0;\n\n    svg {\n      width: ",
        " !important;\n      height: ",
        ";\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  overflow: auto;\n  padding-top: ",
        ";\n  flex-grow: 1;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    padding-top: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  label {\n    color: ",
        ";\n    font-weight: ",
        ";\n    cursor: pointer;\n  }\n\n  input[type='radio'] {\n    opacity: 0;\n    position: absolute;\n    width: 0;\n\n    &:checked + label {\n      color: inherit;\n      cursor: default;\n      border-bottom: 1px solid;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledMobileFilters = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-dc747c16-0"
})(_templateObject(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* screen */.sp)("md"));
var StyledFilters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc747c16-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* shadow */.AF)("sm"), (0,theme/* zindex */.Y0)("filters"), (0,theme/* fontSize */.JB)("extraBold"));
var StyledFiltersHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc747c16-2"
})(_templateObject2(), (0,theme/* color */.$_)("midnight_100"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("midnight_300"));
var StyledFiltersContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc747c16-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledFilterList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc747c16-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* color */.$_)("link"), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/publicProfile/shared/CVFilter.tsx







var CVFilter = function(param) {
    var filters = param.filters, _onFilterChange = param.onFilterChange, onFilterChange = _onFilterChange === void 0 ? function() {
    // NOOP
    } : _onFilterChange, filterTranslationPrefix = param.filterTranslationPrefix;
    var switchFilter = function switchFilter(e) {
        setActiveFilter(e);
        onFilterChange(e);
    };
    var displayMobileFilters = function displayMobileFilters() {
        if (showMobileFilters === false) {
            var ref;
            (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.add("mobile-scroll-blocked");
        } else {
            var ref1;
            (ref1 = document.querySelector("body")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("mobile-scroll-blocked");
        }
        setshowMobileFilters(!showMobileFilters);
    };
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var ref = (0,react.useState)(""), activeFilter = ref[0], setActiveFilter = ref[1];
    var ref1 = (0,react.useState)(false), showMobileFilters = ref1[0], setshowMobileFilters = ref1[1];
    var renderFilters = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filters.filter(function(f) {
                return typeof f !== "undefined";
            }).map(function(filter) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            id: "".concat(filter, "_cvFilter"),
                            name: "cvFilters",
                            defaultChecked: activeFilter === filter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "".concat(filter, "_cvFilter"),
                            onClick: function() {
                                return switchFilter(filter || "");
                            },
                            children: t("".concat(filterTranslationPrefix, ".").concat(filter))
                        })
                    ]
                }, filter);
            })
        });
    }, [
        t,
        activeFilter,
        JSON.stringify(filters)
    ]);
    if (filters && filters.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileFilters, {
                type: "button",
                onClick: displayMobileFilters,
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_solid_svg_icons/* faBarsFilter */.fqi
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("classic.filter.title")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilters, {
                className: "".concat(showMobileFilters ? "is-open" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersHeader, {
                        "aria-hidden": "true",
                        children: [
                            t("classic.filter.filters"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: displayMobileFilters,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_light_svg_icons/* faXmark */.g82
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFiltersContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("classic.filter.viewing")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFilterList, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        id: "all",
                                        name: "cvFilters",
                                        defaultChecked: activeFilter === ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "all",
                                        onClick: function() {
                                            return switchFilter("");
                                        },
                                        children: t("classic.filter.all")
                                    }),
                                    renderFilters()
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_CVFilter = (CVFilter);


/***/ }),

/***/ 30860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ timeline_PublicProfileTimelineComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/ui/publicprofile/publicprofile.service.ts
var publicprofile_service = __webpack_require__(27595);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
// EXTERNAL MODULE: ./components/publicProfile/shared/CVBookmarks.tsx + 3 modules
var CVBookmarks = __webpack_require__(45625);
// EXTERNAL MODULE: ./components/shared/levelLadder/LevelLadder.tsx
var LevelLadder = __webpack_require__(18962);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ./model/index.ts + 29 modules
var model = __webpack_require__(41400);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/publicProfile/timeline/about-me/PublicProfileAbout.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  &:first-of-type {\n    margin-top: ",
        ";\n  }\n\n  ",
        "::before {\n    left: 0;\n    transform: translateX(0);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  &:first-of-type {\n    margin-top: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  ul {\n    padding-left: 1em;\n  }\n\n  li {\n    list-style: disc;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        " ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  width: 18.65rem;\n  font-weight: ",
        ";\n  line-height: 1.25;\n\n  img {\n    width: 3.5rem;\n    height: 3.5rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.25;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  flex: 1 1 auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        " auto 0;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n\n  @media (min-width: ",
        ") {\n    min-width: 22rem;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.25em;\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        " ",
        ";\n  margin-bottom: ",
        ";\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    font-weight: ",
        ";\n\n    img {\n      width: 2.25rem;\n      height: 2.25rem;\n      filter: grayscale(100%);\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  max-width: 35rem;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  ul {\n    padding-left: 1em;\n  }\n\n  li {\n    list-style: disc;\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl4"), Typography_styled/* Heading2 */.XJ);
var StyledSubSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), Typography_styled/* Heading3 */.aC, (0,theme/* spacing */.W0)("md"));
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("md"));
var StyledSkills = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledSkill = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-4"
})(_templateObject4(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("black"));
var StyledLanguages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("md"));
var StyledLanguage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-6"
})(_templateObject6(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontWeight */.Ue)("black"));
var StyledLanguageName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-7"
})(_templateObject7(), (0,theme/* fontWeight */.Ue)("medium"));
var StyledTechs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledTechsTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-1c5ffc37-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_300"));
var StyledTechsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1c5ffc37-10"
})(_templateObject10(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("black"));
var StyledFacts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("md"));
var StyledFact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-12"
})(_templateObject12(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("lg"));
var StyledFactTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1c5ffc37-13"
})(_templateObject13(), (0,theme/* fontWeight */.Ue)("black"));
var StyledFactDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c5ffc37-14"
})(_templateObject14(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_subtle"));

;// CONCATENATED MODULE: ./components/publicProfile/timeline/about-me/PublicProfileAbout.tsx








var PublicProfileAboutMarkdownContent = function(param) {
    var title = param.title, content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                    content: content
                })
            })
        ]
    });
};
var PublicProfileAboutTechs = function(param) {
    var title = param.title, techs = param.techs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsList, {
                children: techs.map(function(t, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: t.iconUrl,
                                alt: t.iconAlt,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t.name
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var PublicProfileAbout = function(param) {
    var publicManfredite = param.publicManfredite;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var intro = publicManfredite.intro, bestPractices = publicManfredite.bestPractices, softSkills = publicManfredite.softSkills, languages = publicManfredite.languages, facts = publicManfredite.facts, techs = publicManfredite.techs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "tabpanel",
        id: "about-tabpanel",
        "aria-labelledby": "about-tab",
        children: [
            publicprofile_service/* default.hasGeneralInfo */.Z.hasGeneralInfo(publicManfredite) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                        editorial: true,
                        children: t("about.generalInfo")
                    }),
                    intro && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileAboutMarkdownContent, {
                        title: t("about.introduction"),
                        content: intro
                    }),
                    bestPractices && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileAboutMarkdownContent, {
                        title: t("about.bestPractices"),
                        content: bestPractices
                    }),
                    softSkills && softSkills.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                children: t("about.skills")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkills, {
                                children: softSkills.map(function(s, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSkill, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: s.iconUrl,
                                                alt: s.iconAlt,
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: s.name
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    }),
                    languages && languages.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                children: t("about.languages")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguages, {
                                children: languages.map(function(l, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLanguage, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLanguageName, {
                                                    children: l.name
                                                }),
                                                l.level !== "not-defined" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelLadder/* default */.Z, {
                                                    level: model/* LANGUAGES_LEVELS.indexOf */.TV.indexOf(l.level)
                                                })
                                            ]
                                        }, i)
                                    });
                                })
                            })
                        ]
                    }),
                    facts && facts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSubSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                                children: t("about.facts")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFacts, {
                                children: facts.map(function(f, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFact, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFactTitle, {
                                                children: f.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFactDesc, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                                    content: f.desc
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            }),
            publicprofile_service/* default.hasAnyTech */.Z.hasAnyTech(publicManfredite) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading2 */.XJ, {
                        editorial: true,
                        children: t("about.techs.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTechs, {
                        children: [
                            (techs === null || techs === void 0 ? void 0 : techs.master) && (techs === null || techs === void 0 ? void 0 : techs.master.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileAboutTechs, {
                                title: t("about.techs.master"),
                                techs: techs.master
                            }),
                            (techs === null || techs === void 0 ? void 0 : techs.like) && (techs === null || techs === void 0 ? void 0 : techs.like.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileAboutTechs, {
                                title: t("about.techs.like"),
                                techs: techs.like
                            }),
                            (techs === null || techs === void 0 ? void 0 : techs.dislike) && (techs === null || techs === void 0 ? void 0 : techs.dislike.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileAboutTechs, {
                                title: t("about.techs.dislike"),
                                techs: techs.dislike
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var about_me_PublicProfileAbout = (PublicProfileAbout);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.tsx
var BadgeFlag = __webpack_require__(67489);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(3716);
// EXTERNAL MODULE: ./components/shared/BadgeFlag.styled.ts
var BadgeFlag_styled = __webpack_require__(66859);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileCard.styled.ts

function PublicProfileCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  position: relative;\n  max-width: 22rem;\n  margin: auto;\n\n  @media (max-width: ",
        ") {\n    margin: unset;\n  }\n\n  ",
        " {\n    margin-top: -",
        ";\n    margin-left: calc(-",
        " - ",
        ");\n    transform: translateY(-50%);\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 3rem;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    width: 1.25rem !important;\n    height: 1.25rem;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    width: 2.5rem;\n    height: 1px;\n    background-color: ",
        ";\n    position: absolute;\n    top: 50%;\n  }\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  display: block;\n"
    ]);
    PublicProfileCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.16;\n  font-weight: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    PublicProfileCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  padding-top: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    PublicProfileCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  padding-left: ",
        ";\n  color: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  -webkit-appearance: none;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n  margin-top: ",
        ";\n  text-align: left;\n  font-family: inherit;\n\n  color: inherit;\n  cursor: pointer;\n  transition: 0.3s;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:active {\n    color: ",
        ";\n  }\n\n  &.is-active {\n    ",
        " svg {\n      transform: rotate(180deg);\n      transform-origin: center center;\n    }\n  }\n\n  > h4 {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: 1.2;\n    font-weight: ",
        ";\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.25;\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n\n  font-weight: ",
        ";\n\n  > * {\n    display: flex;\n    align-items: center;\n  }\n\n  > :first-child::after {\n    content: '';\n    width: ",
        ";\n    height: 1px;\n    background-color: ",
        ";\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: 0;\n  font-weight: ",
        ";\n  white-space: nowrap;\n"
    ]);
    PublicProfileCard_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n  max-height: 0;\n\n  &.is-active {\n    max-height: var(--content-height);\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n    border-top: 0;\n    padding-top: 0;\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        ";\n  margin-bottom: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.5;\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  ul,\n  ol {\n    margin-left: ",
        ";\n  }\n\n  ul li {\n    list-style-type: disc;\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n\n  ~ ",
        " {\n    padding-top: 0;\n  }\n"
    ]);
    PublicProfileCard_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    PublicProfileCard_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.14;\n  text-transform: uppercase;\n  letter-spacing: 0.25em;\n  font-weight: ",
        ";\n  margin-bottom: ",
        ";\n  margin-top: 0;\n"
    ]);
    PublicProfileCard_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function PublicProfileCard_styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    PublicProfileCard_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  width: ",
        ";\n\n  img {\n    max-width: ",
        ";\n    max-height: ",
        ";\n    display: block;\n    filter: grayscale(100%);\n    width: 100%;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}




var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-0"
})(PublicProfileCard_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* screen */.sp)("mdMax"), BadgeFlag_styled/* StyledFlag */.O, (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs2"));
var StyledCardIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-1"
})(PublicProfileCard_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("sand_200"), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"), (0,theme/* color */.$_)("midnight_400"), (0,theme/* color */.$_)("sand_200"), (0,theme/* screen */.sp)("mdMax"));
var StyledLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-2c3d9cdf-2"
})(PublicProfileCard_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"));
var StyledTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-2c3d9cdf-3"
})(PublicProfileCard_styled_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"));
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-4"
})(PublicProfileCard_styled_templateObject4(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("sm"));
var StyledTriggerIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-5"
})(PublicProfileCard_styled_templateObject5(), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("midnight_300"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2c3d9cdf-6"
})(PublicProfileCard_styled_templateObject6(), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("link_hover"), (0,theme/* color */.$_)("link_active"), StyledTriggerIcon, (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-7"
})(PublicProfileCard_styled_templateObject7(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"));
var StyledDateRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-8"
})(PublicProfileCard_styled_templateObject8(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"));
var StyledEllapsedTime = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2c3d9cdf-9"
})(PublicProfileCard_styled_templateObject9(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-10"
})(PublicProfileCard_styled_templateObject10(), StyledLink, (0,theme/* spacing */.W0)("xl"));
var StyledDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-11"
})(PublicProfileCard_styled_templateObject11(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), ButtonLink_styled/* ButtonLink */.Z);
var PublicProfileCard_styled_StyledTechs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-12"
})(PublicProfileCard_styled_templateObject12(), (0,theme/* spacing */.W0)("xl"));
var PublicProfileCard_styled_StyledTechsTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-2c3d9cdf-13"
})(PublicProfileCard_styled_templateObject13(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("sm"));
var PublicProfileCard_styled_StyledTechsList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-2c3d9cdf-14"
})(PublicProfileCard_styled_templateObject14(), (0,theme/* spacing */.W0)("md"));
var StyledTechsItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-2c3d9cdf-15"
})(_templateObject15(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledTechsLogo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-16"
})(_templateObject16(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"));
var StyledType = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c3d9cdf-17"
})(_templateObject17(), (0,theme/* color */.$_)("emerald_900"), (0,theme/* fontSize */.JB)("xs"));

;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileCard.tsx











var PublicProfileCard = function(param) {
    var profileItem = param.profileItem, index = param.index;
    var toggleContent = function toggleContent() {
        setActiveState(setActive === "" ? "is-active" : "");
    };
    var getItemTypeText = function getItemTypeText(item) {
        if (item.cardType === "career") {
            return t("timeline.type.jobPosition");
        }
        if (item.cardType === "certification") {
            return t("timeline.type.certification");
        }
        if (item.cardType === "project") {
            if (!item.type) {
                return "";
            }
            return t("timeline.type.project.".concat(item.type));
        }
        if (item.cardType === "education") {
            if (!item.type) {
                return "";
            }
            return t("timeline.type.education.".concat(item.type));
        }
        if (item.cardType === "highlight") {
            return (item.type ? t("timeline.type.highlight.".concat(item.type)) : "") + (item.category ? ": ".concat(item.category) : "");
        }
        return "";
    };
    var getItemType = function getItemType(item) {
        if (item.cardType === "certification" || item.cardType === "career") {
            return item.cardType;
        } else {
            return item.type;
        }
    };
    var ref, ref1, ref2;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var content = (0,react.useRef)(null);
    var currentHeight = (ref = content.current) === null || ref === void 0 ? void 0 : ref.scrollHeight;
    var ref3 = (0,react.useState)(""), setActive = ref3[0], setActiveState = ref3[1];
    var text = getItemTypeText(profileItem);
    var contentHeight = {
        "--content-height": "".concat(currentHeight, "px")
    };
    var typeIcons = {
        career: pro_solid_svg_icons/* faBriefcase */.HXv,
        OPEN_SOURCE: pro_solid_svg_icons/* faFileCode */.w49,
        SIDE_PROJECT: pro_solid_svg_icons/* faBookSpells */.W9J,
        POST: pro_solid_svg_icons/* faNewspaper */.Xgz,
        TALK: pro_solid_svg_icons/* faKeynote */.XH,
        LAUNCH: pro_solid_svg_icons/* faRocket */.tMT,
        MILESTONE: pro_solid_svg_icons/* faBadgeCheck */.fix,
        VIDEO: pro_solid_svg_icons/* faFilmAlt */.QRc,
        DEGREE: pro_solid_svg_icons/* faGraduationCap */.Xf_,
        COURSE: pro_solid_svg_icons/* faDiploma */.ZJ7,
        SELF_TRAINING: pro_solid_svg_icons/* faHeadSideHeadphones */.cAo,
        certification: pro_solid_svg_icons/* faFileCertificate */.CGe,
        AWARD: pro_solid_svg_icons/* faMedal */._su
    };
    var typeColors = {
        OPEN_SOURCE: "set2_04",
        SIDE_PROJECT: "set1_05",
        LAUNCH: "dark2_03",
        MILESTONE: "set1_02",
        TALK: "set1_05",
        VIDEO: "set1_04",
        POST: "set1_03",
        career: "set1_09",
        DEGREE: "set3_06",
        COURSE: "set3_10",
        SELF_TRAINING: "set3_05",
        certification: "set3_01",
        AWARD: "set1_07"
    };
    var isCertification = getItemType(profileItem) === "certification";
    var trimmedLink = (ref1 = profileItem.link) === null || ref1 === void 0 ? void 0 : ref1.replace(/^https?:\/\//, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardIcon, {
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: typeIcons[getItemType(profileItem) || "POST"]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeFlag/* default */.Z, {
                color: typeColors[getItemType(profileItem) || "POST"],
                icon: typeIcons[getItemType(profileItem) || "POST"],
                text: text
            }),
            profileItem.logoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                src: profileItem.logoUrl,
                alt: profileItem.logoAlt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: profileItem.company
            }),
            profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    href: profileItem.link,
                    rel: "noreferrer",
                    children: trimmedLink
                })
            }),
            (profileItem.desc || profileItem.techs && profileItem.techs.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTrigger, {
                type: "button",
                id: "button_" + index,
                className: "".concat(setActive),
                onClick: toggleContent,
                "aria-expanded": setActive === "is-active",
                "aria-controls": "content_" + index,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: profileItem.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTriggerIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_solid_svg_icons/* faAngleDown */.gc2
                        })
                    })
                ]
            }),
            !profileItem.desc && profileItem.techs && profileItem.techs.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTrigger, {
                as: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: profileItem.title
                })
            }),
            (profileItem.dateInitial || profileItem.dateSingle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDate, {
                children: [
                    profileItem.dateInitial && profileItem.dateFinal && !(0,date/* isSameDateYearAndMonth */.jm)(profileItem.dateInitial, profileItem.dateFinal) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                                    }),
                                    profileItem.dateFinal && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateFinal, locale)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEllapsedTime, {
                                children: [
                                    "(",
                                    publicprofile_service/* default.formatEllapsedTime */.Z.formatEllapsedTime(profileItem.dateInitial.toString(), profileItem.dateFinal.toString(), t),
                                    ")"
                                ]
                            })
                        ]
                    }),
                    profileItem.dateInitial && profileItem.dateFinal && (0,date/* isSameDateYearAndMonth */.jm)(profileItem.dateInitial, profileItem.dateFinal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDateRange, {
                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                    }),
                    profileItem.dateInitial && !profileItem.dateFinal && !isCertification && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("timeline.now")
                            })
                        ]
                    }),
                    profileItem.dateInitial && !profileItem.dateFinal && isCertification && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDateRange, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateInitial, locale)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("timeline.noExpiryDate")
                            })
                        ]
                    }),
                    profileItem.dateSingle && !profileItem.dateInitial && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDateRange, {
                        children: (0,date/* formatDateMonthYear */.NC)(profileItem.dateSingle, locale)
                    })
                ]
            }),
            (profileItem.desc || profileItem.techs && profileItem.techs.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                ref: content,
                id: "content_" + index,
                className: "".concat(setActive),
                style: contentHeight,
                role: "region",
                "aria-labelledby": "button_" + index,
                children: [
                    profileItem.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                            content: profileItem.desc
                        })
                    }),
                    profileItem.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: profileItem.link,
                            children: trimmedLink
                        })
                    }),
                    profileItem.techs && profileItem.techs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PublicProfileCard_styled_StyledTechs, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileCard_styled_StyledTechsTitle, {
                                children: t("timeline.techs")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileCard_styled_StyledTechsList, {
                                children: (ref2 = profileItem.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(t, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTechsItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTechsLogo, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: t.iconUrl,
                                                    alt: t.iconAlt
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t.name
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var timeline_PublicProfileCard = (PublicProfileCard);

;// CONCATENATED MODULE: ./components/publicProfile/timeline/my-story/PublicProfileTimeline.styled.ts

function PublicProfileTimeline_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  max-width: 53rem;\n\n  @media (min-width: ",
        ") {\n    gap: 0;\n    background-image: linear-gradient(\n      to right,\n      transparent,\n      transparent calc(50% - 1px),\n      ",
        " 50%,\n      transparent 50%\n    );\n\n    > div {\n      width: 50%;\n\n      &:nth-of-type(even) {\n        margin-right: auto;\n\n        ",
        " {\n          margin-right: 4.5rem;\n        }\n\n        ",
        " {\n          right: -4.5rem;\n          transform: translateX(50%);\n          &::before {\n            right: 100%;\n          }\n        }\n      }\n\n      &:nth-of-type(odd) {\n        margin-left: auto;\n\n        ",
        " {\n          margin-left: 4.5rem;\n        }\n\n        ",
        " {\n          left: -4.5rem;\n          transform: translateX(-50%);\n          &::before {\n            left: 100%;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    PublicProfileTimeline_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledTimeline = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7879336a-0"
})(PublicProfileTimeline_styled_templateObject(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("sand_200"), StyledCard, StyledCardIcon, StyledCard, StyledCardIcon);

;// CONCATENATED MODULE: ./components/publicProfile/timeline/my-story/PublicProfileTimeline.tsx



var PublicProfileTimeline = function(param) {
    var timeline = param.publicManfredite.timeline;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimeline, {
        role: "tabpanel",
        id: "story-tabpanel",
        "aria-labelledby": "story-tab",
        children: timeline === null || timeline === void 0 ? void 0 : timeline.map(function(p, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(timeline_PublicProfileCard, {
                    profileItem: p,
                    index: i
                })
            }, i);
        })
    });
};
/* harmony default export */ var my_story_PublicProfileTimeline = (PublicProfileTimeline);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ./components/shared/Avatar.tsx
var Avatar = __webpack_require__(6937);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ./components/shared/Avatar.styled.tsx
var Avatar_styled = __webpack_require__(11472);
;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileHeader.styled.ts

function PublicProfileHeader_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        "::before {\n    transform: translateX(0);\n    left: 0;\n  }\n"
    ]);
    PublicProfileHeader_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfileHeader_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.25;\n  font-family: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ",
        ") {\n    font-style: italic;\n    font-size: ",
        ";\n    line-height: 1.14;\n  }\n"
    ]);
    PublicProfileHeader_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfileHeader_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.25;\n  font-family: ",
        ";\n  margin-top: 0;\n  margin-bottom: 0;\n\n  strong {\n    font-weight: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.14;\n    font-style: italic;\n  }\n"
    ]);
    PublicProfileHeader_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfileHeader_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  display: flex;\n"
    ]);
    PublicProfileHeader_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfileHeader_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n    gap: ",
        ";\n  }\n"
    ]);
    PublicProfileHeader_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PublicProfileHeader_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  svg {\n    color: ",
        ";\n    width: ",
        " !important;\n    height: ",
        ";\n\n    @media (min-width: ",
        ") {\n      width: ",
        " !important;\n      height: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileHeader_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-9783a36b-0"
})(PublicProfileHeader_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), Avatar_styled/* StyledAvatar */.b, (0,theme/* spacing */.W0)("xl"), Typography_styled/* Heading1 */.nL);
var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9783a36b-1"
})(PublicProfileHeader_styled_templateObject1(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"));
var StyledLocation = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-9783a36b-2"
})(PublicProfileHeader_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"));
var StyledSocial = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9783a36b-3"
})(PublicProfileHeader_styled_templateObject3(), (0,theme/* spacing */.W0)("lg"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9783a36b-4"
})(PublicProfileHeader_styled_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9783a36b-5"
})(PublicProfileHeader_styled_templateObject5(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("emerald_600"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileHeader.tsx










var PublicProfileHeader = function(param) {
    var _publicManfredite = param.publicManfredite, avatarUrl = _publicManfredite.avatarUrl, avatarAlt = _publicManfredite.avatarAlt, firstName = _publicManfredite.firstName, lastName = _publicManfredite.lastName, headline = _publicManfredite.headline, whereDoYouLive = _publicManfredite.whereDoYouLive, links = _publicManfredite.links, phoneNumber = _publicManfredite.phoneNumber, email = _publicManfredite.email;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var renderLinks = function(links) {
        var icons = {
            twitter: free_brands_svg_icons/* faTwitter */.mdU,
            github: free_brands_svg_icons/* faGithub */.zhw,
            stackOverflow: free_brands_svg_icons/* faStackOverflow */.mGT,
            linkedIn: free_brands_svg_icons/* faLinkedin */.D9H,
            other: free_solid_svg_icons/* faLink */.nNP
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSocial, {
            children: links.map(function(l, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                    content: l === null || l === void 0 ? void 0 : l.desc,
                    direction: "up",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                        sizes: "sm",
                        variant: "tertiary",
                        isIcon: true,
                        href: l.url,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: icons[l.type]
                        })
                    })
                }, "link_".concat(i));
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeader, {
        children: [
            avatarUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                avatarImg: avatarUrl,
                avatarAlt: avatarAlt || "",
                sizes: "lg"
            }),
            (firstName || lastName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_styled/* Heading1 */.nL, {
                editorial: true,
                children: [
                    firstName,
                    " ",
                    lastName
                ]
            }),
            !firstName && !lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading1 */.nL, {
                editorial: true,
                children: t("unknownManfredite")
            }),
            headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntro, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: headline
                })
            }),
            whereDoYouLive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLocation, {
                children: [
                    t("header.in"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: whereDoYouLive
                    })
                ]
            }),
            (email || phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
                children: [
                    email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faEnvelope */.FU$
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:".concat(email),
                                children: email
                            })
                        ]
                    }),
                    phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faPhone */.j1w
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: phoneNumber
                            })
                        ]
                    })
                ]
            }),
            links && renderLinks(links)
        ]
    });
};
/* harmony default export */ var timeline_PublicProfileHeader = (PublicProfileHeader);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileTimelineComponent.styled.ts

function PublicProfileTimelineComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfileTimelineComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin: ",
        " auto;\n  width: 100%;\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin: ",
        " auto;\n  }\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfileTimelineComponent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfileTimelineComponent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  transition: color 0.2s;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-bottom: 0;\n  }\n\n  &::after {\n    content: '/';\n    font-weight: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    color: ",
        ";\n\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfileTimelineComponent_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  background: unset;\n  border: 0;\n  border-bottom: 1px solid transparent;\n  font-family: inherit;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: 0.2s;\n  cursor: pointer;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    padding: ",
        " ",
        ";\n  }\n\n  &.is-active {\n    border-color: ",
        ";\n\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PublicProfileTimelineComponent_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PublicProfileTimelineComponent_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  img {\n    display: block;\n    height: ",
        ";\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  small {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n\n    strong {\n      font-weight: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileTimelineComponent_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var StyledProfile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d1f5bc3-0"
})(PublicProfileTimelineComponent_styled_templateObject());
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d1f5bc3-1"
})(PublicProfileTimelineComponent_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d1f5bc3-2"
})(PublicProfileTimelineComponent_styled_templateObject2(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledTabNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5d1f5bc3-3"
})(PublicProfileTimelineComponent_styled_templateObject3(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* color */.$_)("text_placeholder"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("text_disabled"), (0,theme/* screen */.sp)("mdMax"));
var StyledTab = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5d1f5bc3-4"
})(PublicProfileTimelineComponent_styled_templateObject4(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_active"), StyledTabNumber, (0,theme/* color */.$_)("text_active"));
var StyledTabContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5d1f5bc3-5"
})(PublicProfileTimelineComponent_styled_templateObject5(), (0,theme/* container */.nC)("lg"));
var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-5d1f5bc3-6"
})(PublicProfileTimelineComponent_styled_templateObject6(), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileNavBar.styled.ts

function PublicProfileNavBar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: translateY(-100%);\n  transition: 0.3s;\n  width: 100%;\n  height: 4.25rem;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  box-shadow: ",
        ";\n"
    ]);
    PublicProfileNavBar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PublicProfileNavBar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: unset;\n      ",
        " {\n        transform: translateY(0);\n      }\n    "
    ]);
    PublicProfileNavBar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PublicProfileNavBar_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  z-index: ",
        ";\n  pointer-events: none;\n\n  ",
        "\n"
    ]);
    PublicProfileNavBar_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PublicProfileNavBar_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  max-width: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    PublicProfileNavBar_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PublicProfileNavBar_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n\n  ",
        " {\n    flex-shrink: 0;\n  }\n"
    ]);
    PublicProfileNavBar_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PublicProfileNavBar_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    width: 100%;\n    padding: ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    right: -100%;\n    top: 4.25rem;\n    height: calc(100vh - 4.25rem);\n    transition: right 0.3s;\n    overflow: auto;\n    flex-direction: column;\n    align-items: flex-start;\n\n    &.is-visible {\n      right: 0;\n    }\n  }\n\n  ",
        " {\n    @media (max-width: ",
        ") {\n      flex-direction: row;\n\n      ",
        " {\n        margin-bottom: 0;\n        display: flex;\n        font-size: ",
        ";\n        &::after {\n          display: block;\n        }\n      }\n    }\n\n    @media (max-width: ",
        ") {\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    }\n  }\n"
    ]);
    PublicProfileNavBar_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PublicProfileNavBar_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  background: unset;\n  border: 0;\n  margin-left: auto;\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n"
    ]);
    PublicProfileNavBar_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var StyledNavBarInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d88527-0"
})(PublicProfileNavBar_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* shadow */.AF)("md"));
var StyledNavBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d88527-1"
})(PublicProfileNavBar_styled_templateObject2(), (0,theme/* zindex */.Y0)("profileNavBar"), function(param) {
    var visible = param.visible;
    return visible === true && (0,styled_components_browser_esm/* css */.iv)(PublicProfileNavBar_styled_templateObject1(), StyledNavBarInner);
});
var PublicProfileNavBar_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d88527-2"
})(PublicProfileNavBar_styled_templateObject3(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d88527-3"
})(PublicProfileNavBar_styled_templateObject4(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("black"), Avatar_styled/* StyledAvatar */.b);
var PublicProfileNavBar_styled_StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-92d88527-4"
})(PublicProfileNavBar_styled_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("white"), StyledTab, (0,theme/* screen */.sp)("mdMax"), StyledTabNumber, (0,theme/* fontSize */.JB)("xl2"), (0,theme/* screen */.sp)("lgMax"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"));
var PublicProfileNavBar_styled_StyledTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-92d88527-5"
})(PublicProfileNavBar_styled_templateObject6(), (0,theme/* color */.$_)("midnight_300"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));

;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileNavBar.tsx






var PublicProfileNavBar = function(param) {
    var _publicManfredite = param.publicManfredite, avatarUrl = _publicManfredite.avatarUrl, avatarAlt = _publicManfredite.avatarAlt, firstName = _publicManfredite.firstName, lastName = _publicManfredite.lastName, visible = param.visible, children = param.children, displayMenu = param.displayMenu, displayTabs = param.displayTabs, displayTrigger = param.displayTrigger;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavBar, {
        visible: visible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavBarInner, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PublicProfileNavBar_styled_StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInfo, {
                        children: [
                            avatarUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                avatarImg: avatarUrl,
                                avatarAlt: avatarAlt || "",
                                sizes: "md"
                            }),
                            (firstName || lastName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            !firstName && !lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("unknownManfredite")
                            })
                        ]
                    }),
                    displayTrigger && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PublicProfileNavBar_styled_StyledTrigger, {
                        onClick: function() {
                            return displayMenu();
                        },
                        children: [
                            displayTabs === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faBars */.xiG
                            }),
                            displayTabs === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faClose */.YIN
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicProfileNavBar_styled_StyledTabs, {
                        role: "tablist",
                        "aria-label": t("tabs.title"),
                        className: "".concat(displayTabs && visible ? "is-visible" : ""),
                        children: children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var timeline_PublicProfileNavBar = (PublicProfileNavBar);

;// CONCATENATED MODULE: ./components/publicProfile/timeline/PublicProfileTimelineComponent.tsx















var PublicProfileTimelineComponent = function(param) {
    var publicManfredite = param.publicManfredite;
    var setTab = function setTab(tabName) {
        setActiveTab(tabName);
    };
    var displayMenu = function displayMenu() {
        if (displayTabs === false) {
            var ref;
            (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.add("mobile-scroll-blocked");
        } else {
            var ref1;
            (ref1 = document.querySelector("body")) === null || ref1 === void 0 ? void 0 : ref1.classList.remove("mobile-scroll-blocked");
        }
        setDisplayTabs(!displayTabs);
    };
    var closeMenu = function closeMenu() {
        var ref;
        setDisplayTabs(false);
        (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.classList.remove("mobile-scroll-blocked");
    };
    var ref, ref1;
    var t = (0,useI18n/* useI18n */.Q)("publicProfile").t;
    var locale = (0,router.useRouter)().locale;
    var TABS = [
        {
            id: "about",
            name: t("tabs.aboutme"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(about_me_PublicProfileAbout, {
                publicManfredite: publicManfredite
            }),
            show: publicprofile_service/* default.hasGeneralInfo */.Z.hasGeneralInfo(publicManfredite) || publicprofile_service/* default.hasAnyTech */.Z.hasAnyTech(publicManfredite)
        },
        {
            id: "story",
            name: t("tabs.mystory"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(my_story_PublicProfileTimeline, {
                publicManfredite: publicManfredite
            }),
            show: publicManfredite.timeline && publicManfredite.timeline.length > 0
        },
        {
            id: "bookmarks",
            name: t("tabs.bookmarks"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CVBookmarks/* default */.Z, {
                publicManfredite: publicManfredite
            }),
            show: publicManfredite.bookmarks && publicManfredite.bookmarks.length > 0
        }
    ];
    var VISIBLE_TABS = TABS.filter(function(tab) {
        return tab.show;
    });
    var ref2 = (0,react.useState)(((ref = VISIBLE_TABS[0]) === null || ref === void 0 ? void 0 : ref.id) || ""), activeTab = ref2[0], setActiveTab = ref2[1];
    var ref3 = (0,react.useState)(false), displayTabs = ref3[0], setDisplayTabs = ref3[1];
    var ref4 = (0,react.useState)(false), displayNavBar = ref4[0], setDisplayNavBar = ref4[1];
    var tabsRef = (0,react.useRef)(null);
    var handleScroll = function() {
        if (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) {
            var tabsPosition = tabsRef.current.getBoundingClientRect().bottom;
            if (tabsPosition < 0) {
                setDisplayNavBar(true);
            } else {
                setDisplayNavBar(false);
                setDisplayTabs(false);
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        noTopBar: true,
        noFooter: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(timeline_PublicProfileNavBar, {
                publicManfredite: publicManfredite,
                visible: displayNavBar,
                displayMenu: displayMenu,
                displayTabs: displayTabs && VISIBLE_TABS.length > 1,
                displayTrigger: VISIBLE_TABS.length > 1,
                children: VISIBLE_TABS.map(function(tab, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledTab, {
                        type: "button",
                        role: "tab",
                        "aria-selected": activeTab === tab.id,
                        "aria-controls": "about-tabpanel",
                        id: "about-tab",
                        className: "".concat(activeTab === tab.id ? "is-active" : ""),
                        onClick: function() {
                            setTab(tab.id);
                            closeMenu();
                            if (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) {
                                tabsRef.current.scrollIntoView();
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabNumber, {
                                children: [
                                    "0",
                                    index + 1
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tab.name
                            })
                        ]
                    }, "tab_".concat(tab.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProfile, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(timeline_PublicProfileHeader, {
                                publicManfredite: publicManfredite
                            }),
                            VISIBLE_TABS.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabs, {
                                role: "tablist",
                                "aria-label": t("tabs.title"),
                                ref: tabsRef,
                                children: VISIBLE_TABS.map(function(tab, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, {
                                        type: "button",
                                        role: "tab",
                                        "aria-selected": activeTab === tab.id,
                                        "aria-controls": "about-tabpanel",
                                        id: "about-tab",
                                        className: "".concat(activeTab === tab.id ? "is-active" : ""),
                                        onClick: function() {
                                            return setTab(tab.id);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabNumber, {
                                                children: [
                                                    "0",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: tab.name
                                            })
                                        ]
                                    }, "tab_".concat(tab.id));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTabContent, {
                                children: (ref1 = VISIBLE_TABS.find(function(tab) {
                                    return activeTab === tab.id;
                                })) === null || ref1 === void 0 ? void 0 : ref1.content
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFooter, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("footer.poweredBy")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.home */.uu.home, locale),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: logos/* LOGO_MANFRED */.$q,
                                        alt: "Manfred Tech"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Manfred Tech"
                                    }),
                                    " S.L."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var timeline_PublicProfileTimelineComponent = (PublicProfileTimelineComponent);


/***/ }),

/***/ 66859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  padding: ",
        " ",
        " ",
        " ",
        ";\n  border-left: ",
        " solid ",
        ";\n  margin-left: -",
        ";\n  clip-path: polygon(\n    0 0,\n    100% 0,\n    calc(100% - ",
        ") 50%,\n    100% 100%,\n    0 100%\n  );\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n\n  &.without_icon {\n    padding: ",
        " ",
        " ",
        "\n      ",
        ";\n    font-size: ",
        ";\n  }\n\n  &.set2_04 {\n    background-color: ",
        ";\n  }\n\n  &.set1_05 {\n    background-color: ",
        ";\n  }\n\n  &.set1_03 {\n    background-color: ",
        ";\n  }\n\n  &.set1_01 {\n    background-color: ",
        ";\n  }\n\n  &.set1_04 {\n    background-color: ",
        ";\n  }\n\n  &.set1_02 {\n    background-color: ",
        ";\n  }\n\n  &.set1_07 {\n    background-color: ",
        ";\n  }\n\n  &.set1_09 {\n    background-color: ",
        ";\n  }\n\n  &.set3_04 {\n    background-color: ",
        ";\n  }\n\n  &.set3_10 {\n    background-color: ",
        ";\n  }\n\n  &.set3_05 {\n    background-color: ",
        ";\n  }\n\n  &.set3_01 {\n    background-color: ",
        ";\n  }\n\n  &.pastel1_01 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_02 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_03 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_04 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.pastel1_05 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.AWARD {\n    background-color: ",
        ";\n  }\n\n  &.pastel1_06 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.dark2_03 {\n    background-color: ",
        ";\n  }\n\n  &.set3_06 {\n    background-color: ",
        ";\n  }\n\n  &.positive {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &.negative {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFlag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4debd7d-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set2_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_05"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_03"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_01"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_02"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_07"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_09"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_10"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_05"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_01"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_01"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_02"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_03"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_04"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_05"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set1_07"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("pastel1_06"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("dark2_03"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("set3_06"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_900"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_500"));


/***/ }),

/***/ 67489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var _BadgeFlag_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66859);



var BadgeFlag = function(param) {
    var icon = param.icon, text = param.text, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BadgeFlag_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledFlag */ .O, {
        className: "".concat(color, " ").concat(icon ? "" : "without_icon"),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: icon
            }),
            text
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BadgeFlag);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledMarkdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ul,\n  ol {\n    padding-left: ",
        " !important;\n\n    li {\n      margin-bottom: ",
        ";\n      margin-top: 0 !important;\n    }\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n    }\n  }\n\n  ol {\n    li {\n      list-style-type: numeric;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledMarkdown = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-da6035b2-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));


/***/ }),

/***/ 57792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkdownComponent": function() { return /* binding */ MarkdownComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84864);
/* harmony import */ var rehype_external_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78313);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5636);
/* harmony import */ var _MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(670);





var ALLOWED_ELEMENTS = [
    "p",
    "strong",
    "ul",
    "ol",
    "li",
    "em",
    "a",
    "br",
    "img",
    "u",
    "blockquote"
];
var MarkdownComponent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledMarkdown */ .F, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
            allowedElements: ALLOWED_ELEMENTS,
            rehypePlugins: [
                [
                    rehype_external_links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                    {
                        target: "_blank"
                    }
                ],
                rehype_raw__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
            ],
            children: content
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MarkdownComponent);


/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 3111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ct": function() { return /* binding */ StyledLevelCaption; },
/* harmony export */   "KT": function() { return /* binding */ StyledLevelLadderImage; },
/* harmony export */   "iB": function() { return /* binding */ StyledLevel; },
/* harmony export */   "tF": function() { return /* binding */ StyledLevelLadder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --level1: ",
        ";\n  --level2: ",
        ";\n  --level3: ",
        ";\n  --level4: ",
        ";\n  --level-gradient: linear-gradient(\n    to right,\n    var(--level1),\n    var(--level1) ",
        ",\n    transparent ",
        ",\n    transparent calc(",
        " + ",
        "),\n    var(--level2) calc(",
        " + ",
        "),\n    var(--level2) calc(",
        " + ",
        " + ",
        "),\n    transparent calc(",
        " + ",
        " + ",
        "),\n    transparent\n      calc(\n        ",
        " + ",
        " + ",
        " +\n          ",
        "\n      ),\n    var(--level3)\n      calc(\n        ",
        " + ",
        " + ",
        " +\n          ",
        "\n      )\n  );\n  width: 3.5rem;\n  height: ",
        ";\n  clip-path: polygon(0 100%, 100% 0, 100% 100%);\n  background-image: var(--level-gradient);\n\n  &.level_1 {\n    --level1: ",
        ";\n  }\n  &.level_2 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n  }\n  &.level_3 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n    --level3: ",
        ";\n  }\n  &.level_4 {\n    --level1: ",
        ";\n    --level2: ",
        ";\n    --level3: ",
        ";\n    --level4: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n       {\n        min-width: 7rem;\n\n        ",
        " {\n          --level-gradient: linear-gradient(\n            to right,\n            var(--level1),\n            var(--level1) ",
        ",\n            transparent ",
        ",\n            transparent calc(",
        " + ",
        "),\n            var(--level2) calc(",
        " + ",
        "),\n            var(--level2)\n              calc(",
        " + ",
        " + ",
        "),\n            transparent\n              calc(",
        " + ",
        " + ",
        "),\n            transparent\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        "\n              ),\n            var(--level3)\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        "\n              ),\n            var(--level3)\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        "\n              ),\n            transparent\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        "\n              ),\n            transparent\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        " + ",
        "\n              ),\n            var(--level4)\n              calc(\n                ",
        " + ",
        " + ",
        " +\n                  ",
        " + ",
        " + ",
        "\n              )\n          );\n          width: 4.75rem;\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: ",
        ";\n  margin: 0;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.333;\n  color: ",
        ";\n  text-align: right;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledLevelLadderImage = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-6ff1bdd4-0"
})(_templateObject());
var StyledLevelLadder = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6ff1bdd4-1"
})(_templateObject1(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("sand_150"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("positive_500"));
var StyledLevel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].figure.withConfig */ .ZP.figure.withConfig({
    componentId: "sc-6ff1bdd4-2"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), function(param) {
    var type = param.type;
    return type === "language" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), StyledLevelLadder, (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"));
});
var StyledLevelCaption = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].figcaption.withConfig */ .ZP.figcaption.withConfig({
    componentId: "sc-6ff1bdd4-3"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs2"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle"));


/***/ }),

/***/ 18962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39105);
/* harmony import */ var utils_paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64516);
/* harmony import */ var _LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3111);




var LevelLadder = function(param) {
    var level = param.level, _type = param.type, type = _type === void 0 ? "language" : _type, _useImage = param.useImage, useImage = _useImage === void 0 ? false : _useImage;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_1__/* .useI18n */ .Q)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevel */ .iB, {
        type: type,
        children: [
            useImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevelLadderImage */ .KT, {
                src: (0,utils_paths__WEBPACK_IMPORTED_MODULE_3__/* .getPublicPath */ .A)("/images/level-ladder/level_".concat(level, ".png"))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevelLadder */ .tF, {
                className: "level_" + level
            }),
            type === "language" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_LevelLadder_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledLevelCaption */ .Ct, {
                children: [
                    level === 1 && t("language-selector.level.options.basic"),
                    level === 2 && t("language-selector.level.options.intermediate"),
                    level === 3 && t("language-selector.level.options.fluid"),
                    level === 4 && t("language-selector.level.options.native")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LevelLadder);


/***/ }),

/***/ 27595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var services_service_language_normalizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37031);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75339);
/* harmony import */ var utils_date__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3716);





var UIPublicProfileService = {
    /**
   * Checks if given Manfredite Public info has any tech
   *
   * @param publicManfredite - Public Manfredite info
   * @returns wether the given manfredite has any techs
   */ hasAnyTech: function(publicManfredite) {
        var ref, ref1, ref2;
        return !techsEmpty((ref = publicManfredite.techs) === null || ref === void 0 ? void 0 : ref.master) || !techsEmpty((ref1 = publicManfredite.techs) === null || ref1 === void 0 ? void 0 : ref1.like) || !techsEmpty((ref2 = publicManfredite.techs) === null || ref2 === void 0 ? void 0 : ref2.dislike);
    },
    /**
   * Given two dates, format the ellapsed time string
   *
   * @param from - initial date
   * @param to - end date
   * @param t - i18n translation function
   * @returns wether the given manfredite has any of the general info values
   */ formatEllapsedTime: function(from, to, t) {
        var diff = (0,utils_date__WEBPACK_IMPORTED_MODULE_2__/* .monthDiff */ .Xn)(new Date(from), new Date(to));
        if (diff > 12) {
            var years = Math.abs(Math.floor(diff / 12));
            var months = diff - years * 12;
            if (months > 0) {
                return "".concat(t("timeline.timeDifference.year", {
                    count: years
                }), " ").concat(t("timeline.timeDifference.and"), " ").concat(t("timeline.timeDifference.month", {
                    count: months
                }));
            }
            return t("timeline.timeDifference.year", {
                count: years
            });
        }
        if (diff > 0) {
            return t("timeline.timeDifference.month", {
                count: diff
            });
        }
        return "";
    },
    /**
   * Check if a manfredite has any of the general info values
   *
   * @param publicManfredite - Public Manfredite info
   * @returns wether the given manfredite has any of the general info values
   */ hasGeneralInfo: function(publicManfredite) {
        var intro = publicManfredite.intro, bestPractices = publicManfredite.bestPractices, softSkills = publicManfredite.softSkills, languages = publicManfredite.languages, facts = publicManfredite.facts;
        return !!intro || !!bestPractices || !!softSkills && softSkills.length > 0 || !!languages && languages.length > 0 || !!facts && facts.length > 0;
    },
    /**
   * Get metadata info about the given UIPublicManfredite
   *
   * @param uiPublicManfredite - The UIPublicManfredite from where the Metadata will be extracted
   * @param t - Translation function
   * @returns an object with the title, the desc and the image URL for the metadata
   */ getManfrediteProfileMetadataInfo: function(uiPublicManfredite, t) {
        var MAX_DESC_LENGTH = 140;
        var firstName = uiPublicManfredite.firstName, lastName = uiPublicManfredite.lastName, headline = uiPublicManfredite.headline, intro = uiPublicManfredite.intro, avatarUrl = uiPublicManfredite.avatarUrl;
        var title = !firstName && !lastName ? t("unknownManfredite") : "".concat(firstName || "", " ").concat(lastName || "").trim();
        var headlineText = headline ? "".concat(headline, " - ") : "";
        var desc = "".concat(headlineText).concat(intro);
        if (desc.length > MAX_DESC_LENGTH) {
            desc = "".concat(desc.substring(0, MAX_DESC_LENGTH - 1), "…");
        }
        return {
            title: "".concat(title, " \xb7 CV"),
            desc: desc,
            avatarUrl: avatarUrl
        };
    },
    /**
   * Converts a PublicManfredite to a UIPublicManfredite object
   *
   * @param publicManfredite - Public Manfredite info
   * @param locale - language in which we need the Multilingual texts
   * @returns the UIPublicManfredite object
   */ getManfrediteUIData: function(publicManfredite, appLocale) {
        var ref, ref1;
        var _profile = publicManfredite.profile, avatar = _profile.avatar, firstName = _profile.firstName, lastName = _profile.lastName, links = _profile.links, headline = publicManfredite.headline, whereDoYouLive = publicManfredite.whereDoYouLive, introduction = publicManfredite.introduction, goodPractices = publicManfredite.goodPractices, softSkills = publicManfredite.softSkills, languages = publicManfredite.languages, facts = publicManfredite.facts, techs = publicManfredite.techs, techsLike = publicManfredite.techsLike, techsDislike = publicManfredite.techsDislike;
        var locale = (publicManfredite.preferredLanguage || appLocale || services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_LOCALE */ .Z).toUpperCase();
        return {
            avatarUrl: avatar === null || avatar === void 0 ? void 0 : avatar.url,
            avatarAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(avatar === null || avatar === void 0 ? void 0 : avatar.alt, locale),
            firstName: firstName,
            lastName: lastName,
            headline: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(headline, locale),
            whereDoYouLive: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(whereDoYouLive === null || whereDoYouLive === void 0 ? void 0 : whereDoYouLive.displayName, locale),
            links: getLinksFromProfileLinks(links),
            intro: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(introduction, locale),
            bestPractices: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(goodPractices, locale),
            softSkills: softSkills === null || softSkills === void 0 ? void 0 : softSkills.map(function(skill) {
                var ref, ref1;
                return {
                    name: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(skill.name, locale),
                    iconUrl: (ref = skill.icon) === null || ref === void 0 ? void 0 : ref.url,
                    iconAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = skill.icon) === null || ref1 === void 0 ? void 0 : ref1.alt, locale)
                };
            }),
            languages: languages === null || languages === void 0 ? void 0 : languages.map(function(lang) {
                return {
                    name: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(lang.name, locale),
                    level: services_service_language_normalizer__WEBPACK_IMPORTED_MODULE_0__/* .CommonDtoLevelToLanguageLevelDict */ .x5[lang.level]
                };
            }),
            facts: facts === null || facts === void 0 ? void 0 : facts.map(function(fact) {
                return {
                    title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(fact.title, locale),
                    desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(fact.description, locale)
                };
            }),
            timeline: getTimeline(publicManfredite, locale),
            bookmarks: getBookmarks(publicManfredite, locale),
            techs: techs || techsLike || techsDislike ? {
                master: (techs === null || techs === void 0 ? void 0 : techs.map(function(tech) {
                    return createUITech(tech, locale);
                })) || [],
                like: (techsLike === null || techsLike === void 0 ? void 0 : techsLike.map(function(tech) {
                    return createUITech(tech, locale);
                })) || [],
                dislike: (techsDislike === null || techsDislike === void 0 ? void 0 : techsDislike.map(function(tech) {
                    return createUITech(tech, locale);
                })) || []
            } : undefined,
            email: (ref = publicManfredite.contact) === null || ref === void 0 ? void 0 : ref.email,
            phoneNumber: (ref1 = publicManfredite.contact) === null || ref1 === void 0 ? void 0 : ref1.phone,
            slug: publicManfredite.slug
        };
    }
};
function createUITech(tech, locale) {
    var ref, ref1;
    return {
        name: tech.name,
        iconUrl: ((ref = tech.icon) === null || ref === void 0 ? void 0 : ref.url) || utils_config__WEBPACK_IMPORTED_MODULE_1__/* .config.defaultTechIcon */ .v.defaultTechIcon,
        iconAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = tech.icon) === null || ref1 === void 0 ? void 0 : ref1.alt, locale) || ""
    };
}
function techsEmpty(techs) {
    return !techs || techs.length <= 0;
}
function getLinksFromProfileLinks(links) {
    var uiLinks = [];
    if (!links) {
        return uiLinks;
    }
    if (links.github) {
        uiLinks.push({
            type: "github",
            url: links.github
        });
    }
    if (links.twitter) {
        uiLinks.push({
            type: "twitter",
            url: links.twitter
        });
    }
    if (links.linkedin) {
        uiLinks.push({
            type: "linkedIn",
            url: links.linkedin
        });
    }
    if (links.stackoverflow) {
        uiLinks.push({
            type: "stackOverflow",
            url: links.stackoverflow
        });
    }
    if (links.others) {
        links.others.filter(function(link) {
            return !!link.url;
        }).forEach(function(o) {
            uiLinks.push({
                type: "other",
                url: o.url,
                desc: o.desc
            });
        });
    }
    return uiLinks;
}
function getBookmarks(publicManfredite, locale) {
    var bookmarks = publicManfredite.bookmarks;
    return (bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.map(function(param) {
        var type = param.type, category = param.category, title = param.title, description = param.description, url = param.url, author = param.author, logo = param.logo;
        return {
            type: getType(type) || "OTHER",
            url: url,
            author: author,
            title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(title, locale),
            desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(description, locale),
            category: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(category, locale),
            logoURL: logo === null || logo === void 0 ? void 0 : logo.url,
            logoAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(logo === null || logo === void 0 ? void 0 : logo.alt, locale)
        };
    })) || [];
}
function getTimeline(publicManfredite, locale) {
    var career = publicManfredite.career, projects = publicManfredite.projects, highlights = publicManfredite.highlights, education = publicManfredite.education, certifications = publicManfredite.certifications;
    var publicCareer = getCareerForTimeline(career, locale);
    var publicProjects = getProjectsForTimeline(projects, locale);
    var publicHighlights = getHighlightsForTimeline(highlights, locale);
    var publicEducation = getEducationForTimeline(education, locale);
    var publicCertifications = getCertificationsForTimeline(certifications, locale);
    var timeline = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(publicCareer).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(publicProjects), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(publicHighlights), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(publicEducation), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(publicCertifications));
    var timelineCurrent = timeline.filter(function(i) {
        return i.dateInitial && !i.dateFinal;
    }).sort(sortTimelineItemByDateInitialDesc);
    var timelineEnded = timeline.filter(function(i) {
        return !!i.dateFinal || !!i.dateSingle;
    }).sort(sortTimelineItemByDateSingleDesc);
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(timelineCurrent).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(timelineEnded));
}
function getCareerForTimeline(career, locale) {
    return (career === null || career === void 0 ? void 0 : career.map(function(jobPosition) {
        var ref, ref1, ref2;
        return {
            cardType: "career",
            title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(jobPosition.position, locale),
            company: jobPosition.company,
            logoUrl: (ref = jobPosition.logo) === null || ref === void 0 ? void 0 : ref.url,
            logoAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = jobPosition.logo) === null || ref1 === void 0 ? void 0 : ref1.alt, locale),
            dateTotal: "",
            dateInitial: jobPosition.from,
            dateFinal: jobPosition.to,
            dateSingle: jobPosition.to,
            desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(jobPosition.description, locale),
            link: jobPosition.url,
            techs: ((ref2 = jobPosition.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(tech) {
                return createUITech(tech, locale);
            })) || []
        };
    })) || [];
}
var VALID_TYPES = [
    "OPEN_SOURCE",
    "SIDE_PROJECT",
    "LAUNCH",
    "MILESTONE",
    "POST",
    "TALK",
    "VIDEO",
    "DEGREE",
    "COURSE",
    "SELF_TRAINING",
    "READING",
    "WEBSITE",
    "PODCAST",
    "VIDEO",
    "OTHER",
    "AWARD"
];
function getType(type) {
    return VALID_TYPES.find(function(t) {
        return t === type;
    }) || undefined;
}
function getProjectsForTimeline(projects, locale) {
    return (projects === null || projects === void 0 ? void 0 : projects.map(function(project) {
        var ref, ref1, ref2;
        return {
            cardType: "project",
            type: getType(project.type),
            title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(project.title, locale),
            logoUrl: (ref = project.logo) === null || ref === void 0 ? void 0 : ref.url,
            logoAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = project.logo) === null || ref1 === void 0 ? void 0 : ref1.alt, locale),
            dateTotal: "",
            dateInitial: project.from,
            dateFinal: project.to,
            dateSingle: project.to,
            desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(project.description, locale),
            link: project.url,
            techs: ((ref2 = project.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(tech) {
                return createUITech(tech, locale);
            })) || []
        };
    })) || [];
}
function getHighlightsForTimeline(highlights, locale) {
    return (highlights === null || highlights === void 0 ? void 0 : highlights.map(function(highlight) {
        var ref, ref1, ref2;
        return {
            cardType: "highlight",
            type: getType(highlight.type),
            category: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(highlight.category, locale),
            title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(highlight.title, locale),
            logoUrl: (ref = highlight.logo) === null || ref === void 0 ? void 0 : ref.url,
            logoAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = highlight.logo) === null || ref1 === void 0 ? void 0 : ref1.alt, locale),
            dateTotal: "",
            dateSingle: highlight.date,
            desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(highlight.description, locale),
            link: highlight.url,
            techs: ((ref2 = highlight.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(tech) {
                return createUITech(tech, locale);
            })) || []
        };
    })) || [];
}
function getEducationForTimeline(education, locale) {
    return (education === null || education === void 0 ? void 0 : education.map(function(educationItem) {
        var ref, ref1, ref2;
        return {
            cardType: "education",
            type: getType(educationItem.type),
            title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(educationItem.title, locale),
            company: educationItem.institution,
            logoUrl: (ref = educationItem.logo) === null || ref === void 0 ? void 0 : ref.url,
            logoAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = educationItem.logo) === null || ref1 === void 0 ? void 0 : ref1.alt, locale),
            dateTotal: "",
            dateInitial: educationItem.from,
            dateFinal: educationItem.to,
            dateSingle: educationItem.to,
            desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(educationItem.description, locale),
            link: educationItem.url,
            techs: ((ref2 = educationItem.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(tech) {
                return createUITech(tech, locale);
            })) || []
        };
    })) || [];
}
function getCertificationsForTimeline(certifications, locale) {
    return (certifications === null || certifications === void 0 ? void 0 : certifications.map(function(cert) {
        var ref, ref1, ref2;
        return {
            cardType: "certification",
            title: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(cert.title, locale),
            company: cert.issuingOrganization,
            logoUrl: (ref = cert.logo) === null || ref === void 0 ? void 0 : ref.url,
            logoAlt: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)((ref1 = cert.logo) === null || ref1 === void 0 ? void 0 : ref1.alt, locale),
            dateTotal: "",
            dateInitial: cert.from,
            dateFinal: cert.to,
            dateSingle: cert.to,
            desc: (0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(cert.description, locale),
            link: cert.url,
            techs: ((ref2 = cert.techs) === null || ref2 === void 0 ? void 0 : ref2.map(function(tech) {
                return createUITech(tech, locale);
            })) || []
        };
    })) || [];
}
function sortTimelineItemByDateSingleDesc(a, b) {
    if (a.dateSingle && b.dateSingle) {
        var aDate = new Date(a.dateSingle);
        var bDate = new Date(b.dateSingle);
        if (aDate.getTime() > bDate.getTime()) {
            return -1;
        }
        if (aDate.getTime() < bDate.getTime()) {
            return 1;
        }
    }
    return 0;
}
function sortTimelineItemByDateInitialDesc(a, b) {
    if (a.dateInitial && b.dateInitial) {
        var aDate = new Date(a.dateInitial);
        var bDate = new Date(b.dateInitial);
        if (aDate.getTime() > bDate.getTime()) {
            return -1;
        }
        if (aDate.getTime() < bDate.getTime()) {
            return 1;
        }
    }
    return 0;
}
/* harmony default export */ __webpack_exports__["Z"] = (UIPublicProfileService);


/***/ }),

/***/ 3716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NC": function() { return /* binding */ formatDateMonthYear; },
/* harmony export */   "V9": function() { return /* binding */ sortDateDesc; },
/* harmony export */   "Xn": function() { return /* binding */ monthDiff; },
/* harmony export */   "hp": function() { return /* binding */ sortByDateToAndFrom; },
/* harmony export */   "jm": function() { return /* binding */ isSameDateYearAndMonth; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50930);

function formatDateMonthYear(date, locale) {
    if (!date) {
        return "";
    }
    return new Intl.DateTimeFormat(locale || "en", {
        year: "numeric",
        month: "short"
    }).format(typeof date === "string" ? new Date(date) : date);
}
function formatDate(date, locale) {
    if (!date) {
        return "";
    }
    return new Intl.DateTimeFormat(locale || "en").format(typeof date === "string" ? new Date(date) : date);
}
function formatDateTime(date, locale) {
    if (!date) {
        return "";
    }
    return new Intl.DateTimeFormat(locale || "en", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    }).format(typeof date === "string" ? new Date(date) : date);
}
function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months + 1;
}
/**
 * Sort the given values by the next criteria:
 *
 * - First: all the elements without dateTo, sorted by dateFrom descending
 * - Second: all the elements with dateTo, sorted by dateTo descending
 *
 * @param values array of values to be sorted
 * @returns a new array with the values sorted
 */ function sortByDateToAndFrom(values) {
    var current = values.filter(function(i) {
        return !i.dateTo;
    }).sort(function(a, b) {
        return sortDateDesc(a.dateFrom, b.dateFrom);
    });
    var ended = values.filter(function(i) {
        return !!i.dateTo;
    }).sort(function(a, b) {
        return a.dateTo && b.dateTo ? sortDateDesc(a.dateTo, b.dateTo) : 0;
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(current).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ended));
}
function sortDateDesc(a, b) {
    var aDate = new Date(a);
    var bDate = new Date(b);
    if (aDate.getTime() > bDate.getTime()) {
        return -1;
    }
    if (aDate.getTime() < bDate.getTime()) {
        return 1;
    }
    return 0;
}
function isSameDateYearAndMonth(a, b) {
    if (!a || !b) {
        throw new Error("You must pass a date");
    }
    var aDate = new Date(a);
    var bDate = new Date(b);
    return aDate.getFullYear() === bDate.getFullYear() && aDate.getMonth() === bDate.getMonth();
}


/***/ })

}]);